import * as i0 from '@angular/core';
import { EventEmitter, Directive, Input, Output, forwardRef, HostListener, InjectionToken, APP_INITIALIZER, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DOCUMENT, CommonModule } from '@angular/common';
let ChrAccordionDirective = /*#__PURE__*/(() => {
  class ChrAccordionDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Accordion size
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * Toggles accordion content visibility
     */
    set opened(value) {
      this.element.nativeElement.opened = value;
    }
    get opened() {
      return this.element.nativeElement.opened;
    }
    /**
     * Removes accordion border bottom
     */
    set borderless(value) {
      this.element.nativeElement.borderless = value;
    }
    get borderless() {
      return this.element.nativeElement.borderless;
    }
    /**
     * Accordion header title
     */
    set label(value) {
      this.element.nativeElement.label = value;
    }
    get label() {
      return this.element.nativeElement.label;
    }
    /**
     * Toggles 'opened' state
     */
    toggle() {
      this.element.nativeElement.toggle();
    }
    /**
     * Emits when the opened property is triggered and its new value is true.
     */
    chrOpened = new EventEmitter();
    static ɵfac = function ChrAccordionDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrAccordionDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrAccordionDirective,
      selectors: [["chr-accordion"]],
      inputs: {
        size: "size",
        opened: "opened",
        borderless: "borderless",
        label: "label"
      },
      outputs: {
        chrOpened: "chr-opened"
      }
    });
  }
  return ChrAccordionDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrAvatarDirective = /*#__PURE__*/(() => {
  class ChrAvatarDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Size of the spinner
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * User full name needed to generate initials
     */
    set value(value) {
      this.element.nativeElement.value = value;
    }
    get value() {
      return this.element.nativeElement.value;
    }
    /**
     * Link to the image that will be used as avatar (svg, jpeg, png, etc.)
     */
    set image(value) {
      this.element.nativeElement.image = value;
    }
    get image() {
      return this.element.nativeElement.image;
    }
    static ɵfac = function ChrAvatarDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrAvatarDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrAvatarDirective,
      selectors: [["chr-avatar"]],
      inputs: {
        size: "size",
        value: "value",
        image: "image"
      }
    });
  }
  return ChrAvatarDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrBadgeDirective = /*#__PURE__*/(() => {
  class ChrBadgeDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Describes color palette of badge
     */
    set palette(value) {
      this.element.nativeElement.palette = value;
    }
    get palette() {
      return this.element.nativeElement.palette;
    }
    /**
     * Badge variant
     */
    set variant(value) {
      this.element.nativeElement.variant = value;
    }
    get variant() {
      return this.element.nativeElement.variant;
    }
    /**
     * Badge label
     */
    set label(value) {
      this.element.nativeElement.label = value;
    }
    get label() {
      return this.element.nativeElement.label;
    }
    /**
     * Icon to be displayed in badge.
     * If you need to add icon outside of CIPHR default icon set, please use &#x60;icon&#x60; named slot instead
     */
    set icon(value) {
      this.element.nativeElement.icon = value;
    }
    get icon() {
      return this.element.nativeElement.icon;
    }
    static ɵfac = function ChrBadgeDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrBadgeDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrBadgeDirective,
      selectors: [["chr-badge"]],
      inputs: {
        palette: "palette",
        variant: "variant",
        label: "label",
        icon: "icon"
      }
    });
  }
  return ChrBadgeDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrButtonDirective = /*#__PURE__*/(() => {
  class ChrButtonDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Button size
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * Disables the button
     */
    set disabled(value) {
      this.element.nativeElement.disabled = value;
    }
    get disabled() {
      return this.element.nativeElement.disabled;
    }
    /**
     * Shows loading spinner instead of button label
     */
    set loading(value) {
      this.element.nativeElement.loading = value;
    }
    get loading() {
      return this.element.nativeElement.loading;
    }
    /**
     * Describes color palette of the element
     */
    set palette(value) {
      this.element.nativeElement.palette = value;
    }
    get palette() {
      return this.element.nativeElement.palette;
    }
    /**
     * Button variant
     */
    set variant(value) {
      this.element.nativeElement.variant = value;
    }
    get variant() {
      return this.element.nativeElement.variant;
    }
    /**
     * Label
     */
    set label(value) {
      this.element.nativeElement.label = value;
    }
    get label() {
      return this.element.nativeElement.label;
    }
    /**
     * Payload that will be emitted in action&#x27;s event detail
     */
    set payload(value) {
      this.element.nativeElement.payload = value;
    }
    get payload() {
      return this.element.nativeElement.payload;
    }
    /**
     * Whether button should submit associated form.
     */
    set submit(value) {
      this.element.nativeElement.submit = value;
    }
    get submit() {
      return this.element.nativeElement.submit;
    }
    /**
     * Prepending icon of the button
     * If you need to insert icon outside of CIPHR default icon set, please yse &#x60;icon-before&#x60;
     * named slot instead.
     */
    set iconBefore(value) {
      this.element.nativeElement.iconBefore = value;
    }
    get iconBefore() {
      return this.element.nativeElement.iconBefore;
    }
    /**
     * Appending icon of the button
     * If you need to insert icon outside of CIPHR default icon set, please yse &#x60;icon-after&#x60;
     * named slot instead.
     */
    set iconAfter(value) {
      this.element.nativeElement.iconAfter = value;
    }
    get iconAfter() {
      return this.element.nativeElement.iconAfter;
    }
    /**
     * Set the focus on a specific element
     */
    focus(options) {
      this.element.nativeElement.focus(options);
    }
    /**
     * Remove the focus from an element making it inactive
     */
    blur() {
      this.element.nativeElement.blur();
    }
    /**
     * Emits when button is clicked.
     */
    chrAction = new EventEmitter();
    static ɵfac = function ChrButtonDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrButtonDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrButtonDirective,
      selectors: [["chr-button"]],
      inputs: {
        size: "size",
        disabled: "disabled",
        loading: "loading",
        palette: "palette",
        variant: "variant",
        label: "label",
        payload: "payload",
        submit: "submit",
        iconBefore: [0, "icon-before", "iconBefore"],
        iconAfter: [0, "icon-after", "iconAfter"]
      },
      outputs: {
        chrAction: "chr-action"
      }
    });
  }
  return ChrButtonDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrButtonGroupDirective = /*#__PURE__*/(() => {
  class ChrButtonGroupDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Size of the button group items
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * Describes color palette of the button group items
     */
    set palette(value) {
      this.element.nativeElement.palette = value;
    }
    get palette() {
      return this.element.nativeElement.palette;
    }
    /**
     * Marks button group to shows icons only if set to true (slots-before).
     * Labels and slots-after are hidden.
     */
    set compact(value) {
      this.element.nativeElement.compact = value;
    }
    get compact() {
      return this.element.nativeElement.compact;
    }
    /**
     * Emits when button group item is clicked and not disabled.
     */
    chrButtonSelected = new EventEmitter();
    static ɵfac = function ChrButtonGroupDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrButtonGroupDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrButtonGroupDirective,
      selectors: [["chr-button-group"]],
      inputs: {
        size: "size",
        palette: "palette",
        compact: "compact"
      },
      outputs: {
        chrButtonSelected: "chr-button-selected"
      }
    });
  }
  return ChrButtonGroupDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrButtonGroupItemDirective = /*#__PURE__*/(() => {
  class ChrButtonGroupItemDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Marks button group item as selected.
     */
    set selected(value) {
      this.element.nativeElement.selected = value;
    }
    get selected() {
      return this.element.nativeElement.selected;
    }
    /**
     * Marks button group item as disabled.
     */
    set disabled(value) {
      this.element.nativeElement.disabled = value;
    }
    get disabled() {
      return this.element.nativeElement.disabled;
    }
    /**
     * Label of the button group item.
     * It&#x27;s hidden when compact is set to true.
     */
    set label(value) {
      this.element.nativeElement.label = value;
    }
    get label() {
      return this.element.nativeElement.label;
    }
    /**
     * Value that will be emitted in action&#x27;s event detail.
     */
    set payload(value) {
      this.element.nativeElement.payload = value;
    }
    get payload() {
      return this.element.nativeElement.payload;
    }
    /**
     * Prepending icon of the button
     * If you need to insert icon outside of CIPHR default icon set, please yse &#x60;icon-before&#x60;
     * named slot instead.
     */
    set iconBefore(value) {
      this.element.nativeElement.iconBefore = value;
    }
    get iconBefore() {
      return this.element.nativeElement.iconBefore;
    }
    /**
     * Appending icon of the button
     * If you need to insert icon outside of CIPHR default icon set, please yse &#x60;icon-after&#x60;
     * named slot instead.
     */
    set iconAfter(value) {
      this.element.nativeElement.iconAfter = value;
    }
    get iconAfter() {
      return this.element.nativeElement.iconAfter;
    }
    /**
     * Sets 'selected' state for the button-group-item.
     */
    select() {
      this.element.nativeElement.select();
    }
    /**
     * Removes 'selected' state from button-group-item
     */
    deselect() {
      this.element.nativeElement.deselect();
    }
    /**
     * Toggles 'selected' state for the button-group-item.
     */
    toggle() {
      this.element.nativeElement.toggle();
    }
    /**
     * Set the focus on a specific element
     */
    focus(options) {
      this.element.nativeElement.focus(options);
    }
    /**
     * Remove the focus from an element making it inactive
     */
    blur() {
      this.element.nativeElement.blur();
    }
    /**
     * Emits when button group item is clicked.
     */
    chrSelected = new EventEmitter();
    static ɵfac = function ChrButtonGroupItemDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrButtonGroupItemDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrButtonGroupItemDirective,
      selectors: [["chr-button-group-item"]],
      inputs: {
        selected: "selected",
        disabled: "disabled",
        label: "label",
        payload: "payload",
        iconBefore: [0, "icon-before", "iconBefore"],
        iconAfter: [0, "icon-after", "iconAfter"]
      },
      outputs: {
        chrSelected: "chr-selected"
      }
    });
  }
  return ChrButtonGroupItemDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrButtonIconDirective = /*#__PURE__*/(() => {
  class ChrButtonIconDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Describes button size
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * Describes if button should be disabled
     */
    set disabled(value) {
      this.element.nativeElement.disabled = value;
    }
    get disabled() {
      return this.element.nativeElement.disabled;
    }
    /**
     * Describes loading state
     */
    set loading(value) {
      this.element.nativeElement.loading = value;
    }
    get loading() {
      return this.element.nativeElement.loading;
    }
    /**
     * Describes color palette of the element
     */
    set palette(value) {
      this.element.nativeElement.palette = value;
    }
    get palette() {
      return this.element.nativeElement.palette;
    }
    /**
     * Describes variant of the button
     */
    set variant(value) {
      this.element.nativeElement.variant = value;
    }
    get variant() {
      return this.element.nativeElement.variant;
    }
    /**
     * Value that will be emitted in action&#x27;s event detail
     */
    set payload(value) {
      this.element.nativeElement.payload = value;
    }
    get payload() {
      return this.element.nativeElement.payload;
    }
    /**
     * Icon to be displayed in button.
     * If you need to add icon outside of CIPHR default icon set, please use &#x60;icon&#x60; named slot instead
     */
    set icon(value) {
      this.element.nativeElement.icon = value;
    }
    get icon() {
      return this.element.nativeElement.icon;
    }
    /**
     * Set the focus on a specific element
     */
    focus(options) {
      this.element.nativeElement.focus(options);
    }
    /**
     * Remove the focus from an element making it inactive
     */
    blur() {
      this.element.nativeElement.blur();
    }
    /**
     * Emits when button is clicked and not disabled.
     */
    chrAction = new EventEmitter();
    static ɵfac = function ChrButtonIconDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrButtonIconDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrButtonIconDirective,
      selectors: [["chr-button-icon"]],
      inputs: {
        size: "size",
        disabled: "disabled",
        loading: "loading",
        palette: "palette",
        variant: "variant",
        payload: "payload",
        icon: "icon"
      },
      outputs: {
        chrAction: "chr-action"
      }
    });
  }
  return ChrButtonIconDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrCalendarDirective = /*#__PURE__*/(() => {
  class ChrCalendarDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Indicate whether the user can select a date range or a single date.
     */
    set range(value) {
      this.element.nativeElement.range = value;
    }
    get range() {
      return this.element.nativeElement.range;
    }
    /**
     * Single date or date range
     */
    set date(value) {
      this.element.nativeElement.date = value;
    }
    get date() {
      return this.element.nativeElement.date;
    }
    /**
     * Minimum date user can select.
     */
    set minDate(value) {
      this.element.nativeElement.minDate = value;
    }
    get minDate() {
      return this.element.nativeElement.minDate;
    }
    /**
     * Maximum date user can select.
     */
    set maxDate(value) {
      this.element.nativeElement.maxDate = value;
    }
    get maxDate() {
      return this.element.nativeElement.maxDate;
    }
    /**
     * Disabled dates user cannot select.
     */
    set disabledDates(value) {
      this.element.nativeElement.disabledDates = value;
    }
    get disabledDates() {
      return this.element.nativeElement.disabledDates;
    }
    /**
     * Language code (ISO 639-1 + optional country code)
     */
    set lang(value) {
      this.element.nativeElement.lang = value;
    }
    get lang() {
      return this.element.nativeElement.lang;
    }
    /**
     * Sets focus on a calendar
     */
    focus(options) {
      this.element.nativeElement.focus(options);
    }
    /**
     * Removes focus from calendar making it inactive
     */
    blur() {
      this.element.nativeElement.blur();
    }
    /**
     * Selects provided data
     */
    select(date) {
      this.element.nativeElement.select(date);
    }
    /**
     * Emits when grid cell is selected.
     */
    chrDateSelected = new EventEmitter();
    /**
     * Emits when grid cell is hovered.
     */
    chrDateHovered = new EventEmitter();
    onChange = () => {};
    onTouch = () => {};
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouch = fn;
    }
    writeValue(value) {
      this.element.nativeElement.value = value;
    }
    static ɵfac = function ChrCalendarDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrCalendarDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrCalendarDirective,
      selectors: [["chr-calendar"]],
      inputs: {
        range: "range",
        date: "date",
        minDate: [0, "min-date", "minDate"],
        maxDate: [0, "max-date", "maxDate"],
        disabledDates: "disabledDates",
        lang: "lang"
      },
      outputs: {
        chrDateSelected: "chr-date-selected",
        chrDateHovered: "chr-date-hovered"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ChrCalendarDirective),
        multi: true
      }])]
    });
  }
  return ChrCalendarDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrCheckboxDirective = /*#__PURE__*/(() => {
  class ChrCheckboxDirective {
    element;
    previousValue;
    constructor(element) {
      this.element = element;
    }
    /**
     * Size of the checkbox
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * Marks checkbox as checked
     */
    set checked(value) {
      this.element.nativeElement.checked = value;
    }
    get checked() {
      return this.element.nativeElement.checked;
    }
    /**
     * Marks checkbox as indeterminate
     */
    set indeterminate(value) {
      this.element.nativeElement.indeterminate = value;
    }
    get indeterminate() {
      return this.element.nativeElement.indeterminate;
    }
    /**
     * Marks checkbox as disabled
     */
    set disabled(value) {
      this.element.nativeElement.disabled = value;
    }
    get disabled() {
      return this.element.nativeElement.disabled;
    }
    /**
     * Mark the checkbox as required to be checked before submitting the form
     */
    set required(value) {
      this.element.nativeElement.required = value;
    }
    get required() {
      return this.element.nativeElement.required;
    }
    /**
     * Mark the checkbox as readonly
     */
    set readonly(value) {
      this.element.nativeElement.readonly = value;
    }
    get readonly() {
      return this.element.nativeElement.readonly;
    }
    /**
     * Checkbox value
     */
    set value(value) {
      this.element.nativeElement.value = value;
    }
    get value() {
      return this.element.nativeElement.value;
    }
    /**
     * Marks checkbox as not valid
     */
    set error(value) {
      this.element.nativeElement.error = value;
    }
    get error() {
      return this.element.nativeElement.error;
    }
    /**
     * validation message - error
     */
    set explicitValidationMessage(value) {
      this.element.nativeElement.explicitValidationMessage = value;
    }
    get explicitValidationMessage() {
      return this.element.nativeElement.explicitValidationMessage;
    }
    /**
     * Toggles 'checked' state for the checkbox
     */
    toggle() {
      this.element.nativeElement.toggle();
    }
    /**
     * Sets 'checked' state for the checkbox
     */
    select() {
      this.element.nativeElement.select();
    }
    /**
     * Removes 'checked' state from the checkbox
     */
    deselect() {
      this.element.nativeElement.deselect();
    }
    /**
     * Sets specific state for the checkbox (checked / indeterminate)
     */
    set(value) {
      this.element.nativeElement.set(value);
    }
    /**
     * Clears checkbox state
     */
    clear() {
      this.element.nativeElement.clear();
    }
    /**
     * Set the focus on a specific element
     */
    focus(options) {
      this.element.nativeElement.focus(options);
    }
    /**
     * Remove the focus from an element making it inactive
     */
    blur() {
      this.element.nativeElement.blur();
    }
    change = new EventEmitter();
    handleChange() {
      this.handleValueChange();
    }
    handleValueChange() {
      const currentValue = this.element.nativeElement.value;
      if (currentValue !== this.previousValue) {
        this.previousValue = currentValue;
        this.onChange(currentValue);
      }
    }
    onChange = () => {};
    onTouch = () => {};
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouch = fn;
    }
    writeValue(value) {
      this.element.nativeElement.checked = value;
    }
    setDisabledState(disabled) {
      this.disabled = disabled;
    }
    static ɵfac = function ChrCheckboxDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrCheckboxDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrCheckboxDirective,
      selectors: [["chr-checkbox"]],
      hostBindings: function ChrCheckboxDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("change", function ChrCheckboxDirective_change_HostBindingHandler() {
            return ctx.handleChange();
          });
        }
      },
      inputs: {
        size: "size",
        checked: "checked",
        indeterminate: "indeterminate",
        disabled: "disabled",
        required: "required",
        readonly: "readonly",
        value: "value",
        error: "error",
        explicitValidationMessage: [0, "validation-message", "explicitValidationMessage"]
      },
      outputs: {
        change: "change"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ChrCheckboxDirective),
        multi: true
      }])]
    });
  }
  return ChrCheckboxDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrCheckboxGroupDirective = /*#__PURE__*/(() => {
  class ChrCheckboxGroupDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Size of the checkbox-group elements
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * Specifies layout direction of the checkboxes within the group
     */
    set direction(value) {
      this.element.nativeElement.direction = value;
    }
    get direction() {
      return this.element.nativeElement.direction;
    }
    /**
     * Mark the checkbox-group as required.
     * Suggest that at least one should be checked before submitting the form
     */
    set required(value) {
      this.element.nativeElement.required = value;
    }
    get required() {
      return this.element.nativeElement.required;
    }
    /**
     * Prevents users from interacting with the checkboxes, allowing only to display of pre-set or default values.
     */
    set readonly(value) {
      this.element.nativeElement.readonly = value;
    }
    get readonly() {
      return this.element.nativeElement.readonly;
    }
    /**
     * Marks component as not valid
     */
    set error(value) {
      this.element.nativeElement.error = value;
    }
    get error() {
      return this.element.nativeElement.error;
    }
    /**
     * Marks component as a valid
     */
    set success(value) {
      this.element.nativeElement.success = value;
    }
    get success() {
      return this.element.nativeElement.success;
    }
    /**
     * Marks component as conditionally valid
     */
    set warning(value) {
      this.element.nativeElement.warning = value;
    }
    get warning() {
      return this.element.nativeElement.warning;
    }
    /**
     * Validation message - success, error or warning
     */
    set explicitValidationMessage(value) {
      this.element.nativeElement.explicitValidationMessage = value;
    }
    get explicitValidationMessage() {
      return this.element.nativeElement.explicitValidationMessage;
    }
    onChange = () => {};
    onTouch = () => {};
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouch = fn;
    }
    writeValue(value) {
      this.element.nativeElement.value = value;
    }
    static ɵfac = function ChrCheckboxGroupDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrCheckboxGroupDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrCheckboxGroupDirective,
      selectors: [["chr-checkbox-group"]],
      inputs: {
        size: "size",
        direction: "direction",
        required: "required",
        readonly: "readonly",
        error: "error",
        success: "success",
        warning: "warning",
        explicitValidationMessage: [0, "validation-message", "explicitValidationMessage"]
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ChrCheckboxGroupDirective),
        multi: true
      }])]
    });
  }
  return ChrCheckboxGroupDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrChipDirective = /*#__PURE__*/(() => {
  class ChrChipDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Marks chip as disabled
     */
    set disabled(value) {
      this.element.nativeElement.disabled = value;
    }
    get disabled() {
      return this.element.nativeElement.disabled;
    }
    /**
     * Mark component as possible to be removed (set icon at the end of chip component)
     * Enables emitting &#x27;chr-remove&#x27; event on click when chip is not disabled
     */
    set removable(value) {
      this.element.nativeElement.removable = value;
    }
    get removable() {
      return this.element.nativeElement.removable;
    }
    /**
     * Chip label
     */
    set label(value) {
      this.element.nativeElement.label = value;
    }
    get label() {
      return this.element.nativeElement.label;
    }
    /**
     * Icon to be displayed in badge.
     * If you need to add icon outside of CIPHR default icon set, please use &#x60;icon&#x60; named slot instead
     */
    set icon(value) {
      this.element.nativeElement.icon = value;
    }
    get icon() {
      return this.element.nativeElement.icon;
    }
    /**
     * Emits event on click when chip is not disabled.
     */
    chrAction = new EventEmitter();
    /**
     * Emits event when chip is removable and not disabled and remove icon was clicked.
     */
    chrRemove = new EventEmitter();
    static ɵfac = function ChrChipDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrChipDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrChipDirective,
      selectors: [["chr-chip"]],
      inputs: {
        disabled: "disabled",
        removable: "removable",
        label: "label",
        icon: "icon"
      },
      outputs: {
        chrAction: "chr-action",
        chrRemove: "chr-remove"
      }
    });
  }
  return ChrChipDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrDatepickerDirective = /*#__PURE__*/(() => {
  class ChrDatepickerDirective {
    element;
    previousValue;
    constructor(element) {
      this.element = element;
    }
    /**
     * Datepicker value in default dd/MMM/yyyy format
     */
    set value(value) {
      this.element.nativeElement.value = value;
    }
    get value() {
      return this.element.nativeElement.value;
    }
    /**
     * Datepicker date
     */
    set date(value) {
      this.element.nativeElement.date = value;
    }
    get date() {
      return this.element.nativeElement.date;
    }
    /**
     * Minimum date user can select.
     */
    set minDate(value) {
      this.element.nativeElement.minDate = value;
    }
    get minDate() {
      return this.element.nativeElement.minDate;
    }
    /**
     * Maximum date user can select.
     */
    set maxDate(value) {
      this.element.nativeElement.maxDate = value;
    }
    get maxDate() {
      return this.element.nativeElement.maxDate;
    }
    /**
     * Disabled dates user cannot select.
     */
    set disabledDates(value) {
      this.element.nativeElement.disabledDates = value;
    }
    get disabledDates() {
      return this.element.nativeElement.disabledDates;
    }
    /**
     * Date format
     */
    set format(value) {
      this.element.nativeElement.format = value;
    }
    get format() {
      return this.element.nativeElement.format;
    }
    /**
     * Language code (ISO 639-1 + optional country code)
     */
    set lang(value) {
      this.element.nativeElement.lang = value;
    }
    get lang() {
      return this.element.nativeElement.lang;
    }
    /**
     * Whether datepicker should be disabled
     */
    set disabled(value) {
      this.element.nativeElement.disabled = value;
    }
    get disabled() {
      return this.element.nativeElement.disabled;
    }
    /**
     * Mark datepicker as required to be filled before submitting the form
     */
    set required(value) {
      this.element.nativeElement.required = value;
    }
    get required() {
      return this.element.nativeElement.required;
    }
    /**
     * Mark the datepicker as readonly
     */
    set readonly(value) {
      this.element.nativeElement.readonly = value;
    }
    get readonly() {
      return this.element.nativeElement.readonly;
    }
    /**
     * Placeholder for datepicker control
     */
    set placeholder(value) {
      this.element.nativeElement.placeholder = value;
    }
    get placeholder() {
      return this.element.nativeElement.placeholder;
    }
    /**
     * Whether datepicker should display button for clearing the inputs value.
     */
    set clearable(value) {
      this.element.nativeElement.clearable = value;
    }
    get clearable() {
      return this.element.nativeElement.clearable;
    }
    /**
     * Datepicker size
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * Marks component as a valid
     */
    set success(value) {
      this.element.nativeElement.success = value;
    }
    get success() {
      return this.element.nativeElement.success;
    }
    /**
     * Marks component as not valid
     */
    set error(value) {
      this.element.nativeElement.error = value;
    }
    get error() {
      return this.element.nativeElement.error;
    }
    /**
     * Marks component as conditionally valid
     */
    set warning(value) {
      this.element.nativeElement.warning = value;
    }
    get warning() {
      return this.element.nativeElement.warning;
    }
    /**
     * Validation message - success, error or warning
     */
    set explicitValidationMessage(value) {
      this.element.nativeElement.explicitValidationMessage = value;
    }
    get explicitValidationMessage() {
      return this.element.nativeElement.explicitValidationMessage;
    }
    /**
     * Field name for screen readers. This should be used only when field is used without chr-label element.
     */
    set explicitLabel(value) {
      this.element.nativeElement.explicitLabel = value;
    }
    get explicitLabel() {
      return this.element.nativeElement.explicitLabel;
    }
    /**
     * Field description for screen readers. This should be used only when field is used without chr-label element.
     */
    set explicitDescription(value) {
      this.element.nativeElement.explicitDescription = value;
    }
    get explicitDescription() {
      return this.element.nativeElement.explicitDescription;
    }
    /**
     * Set provided date as datepicker value
     */
    set(value) {
      this.element.nativeElement.set(value);
    }
    /**
     * Clear datepicker value
     */
    clear() {
      this.element.nativeElement.clear();
    }
    /**
     * Set focus on a datepicker
     */
    focus(options) {
      this.element.nativeElement.focus(options);
    }
    /**
     * Remove focus from datepicker making it inactive
     */
    blur() {
      this.element.nativeElement.blur();
    }
    input = new EventEmitter();
    change = new EventEmitter();
    handleInput() {
      this.handleValueChange();
    }
    handleChange() {
      this.handleValueChange();
    }
    handleValueChange() {
      const currentValue = this.element.nativeElement.value;
      if (currentValue !== this.previousValue) {
        this.previousValue = currentValue;
        this.onChange(currentValue);
      }
    }
    onChange = () => {};
    onTouch = () => {};
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouch = fn;
    }
    writeValue(value) {
      this.element.nativeElement.value = value;
    }
    setDisabledState(disabled) {
      this.disabled = disabled;
    }
    static ɵfac = function ChrDatepickerDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrDatepickerDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrDatepickerDirective,
      selectors: [["chr-datepicker"]],
      hostBindings: function ChrDatepickerDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("input", function ChrDatepickerDirective_input_HostBindingHandler() {
            return ctx.handleInput();
          })("change", function ChrDatepickerDirective_change_HostBindingHandler() {
            return ctx.handleChange();
          });
        }
      },
      inputs: {
        value: "value",
        date: "date",
        minDate: [0, "min-date", "minDate"],
        maxDate: [0, "max-date", "maxDate"],
        disabledDates: "disabledDates",
        format: "format",
        lang: "lang",
        disabled: "disabled",
        required: "required",
        readonly: "readonly",
        placeholder: "placeholder",
        clearable: "clearable",
        size: "size",
        success: "success",
        error: "error",
        warning: "warning",
        explicitValidationMessage: [0, "validation-message", "explicitValidationMessage"],
        explicitLabel: [0, "label", "explicitLabel"],
        explicitDescription: [0, "description", "explicitDescription"]
      },
      outputs: {
        input: "input",
        change: "change"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ChrDatepickerDirective),
        multi: true
      }])]
    });
  }
  return ChrDatepickerDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrFormFieldDirective = /*#__PURE__*/(() => {
  class ChrFormFieldDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Size of the slotted elements with size property
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * Whether form control is required or not
     */
    set required(value) {
      this.element.nativeElement.required = value;
    }
    get required() {
      return this.element.nativeElement.required;
    }
    onChange = () => {};
    onTouch = () => {};
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouch = fn;
    }
    writeValue(value) {
      this.element.nativeElement.value = value;
    }
    static ɵfac = function ChrFormFieldDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrFormFieldDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrFormFieldDirective,
      selectors: [["chr-form-field"]],
      inputs: {
        size: "size",
        required: "required"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ChrFormFieldDirective),
        multi: true
      }])]
    });
  }
  return ChrFormFieldDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrHelperDirective = /*#__PURE__*/(() => {
  class ChrHelperDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Size of the helper
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * Text to show in helper
     */
    set content(value) {
      this.element.nativeElement.content = value;
    }
    get content() {
      return this.element.nativeElement.content;
    }
    /**
     * Display success helper
     */
    set success(value) {
      this.element.nativeElement.success = value;
    }
    get success() {
      return this.element.nativeElement.success;
    }
    /**
     * Display warning helper
     */
    set warning(value) {
      this.element.nativeElement.warning = value;
    }
    get warning() {
      return this.element.nativeElement.warning;
    }
    /**
     * Display error helper
     */
    set error(value) {
      this.element.nativeElement.error = value;
    }
    get error() {
      return this.element.nativeElement.error;
    }
    static ɵfac = function ChrHelperDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrHelperDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrHelperDirective,
      selectors: [["chr-helper"]],
      inputs: {
        size: "size",
        content: "content",
        success: "success",
        warning: "warning",
        error: "error"
      }
    });
  }
  return ChrHelperDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrIconDirective = /*#__PURE__*/(() => {
  class ChrIconDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Name of the icon
     * Please remember to register icons set first!
     */
    set name(value) {
      this.element.nativeElement.name = value;
    }
    get name() {
      return this.element.nativeElement.name;
    }
    /**
     * Icon size
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    static ɵfac = function ChrIconDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrIconDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrIconDirective,
      selectors: [["chr-icon"]],
      inputs: {
        name: "name",
        size: "size"
      }
    });
  }
  return ChrIconDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrIllustrationDirective = /*#__PURE__*/(() => {
  class ChrIllustrationDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Name of the illustration.
     * Please remember to register illustrations set first!
     */
    set name(value) {
      this.element.nativeElement.name = value;
    }
    get name() {
      return this.element.nativeElement.name;
    }
    /**
     * Illustration palette
     */
    set palette(value) {
      this.element.nativeElement.palette = value;
    }
    get palette() {
      return this.element.nativeElement.palette;
    }
    /**
     * Determines if the component should be plain SVG or container with a background image.
     */
    set background(value) {
      this.element.nativeElement.background = value;
    }
    get background() {
      return this.element.nativeElement.background;
    }
    static ɵfac = function ChrIllustrationDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrIllustrationDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrIllustrationDirective,
      selectors: [["chr-illustration"]],
      inputs: {
        name: "name",
        palette: "palette",
        background: "background"
      }
    });
  }
  return ChrIllustrationDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrInlineMessageDirective = /*#__PURE__*/(() => {
  class ChrInlineMessageDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Describes color palette of the inline-message
     */
    set palette(value) {
      this.element.nativeElement.palette = value;
    }
    get palette() {
      return this.element.nativeElement.palette;
    }
    /**
     * Inline-message title
     */
    set title(value) {
      this.element.nativeElement.title = value;
    }
    get title() {
      return this.element.nativeElement.title;
    }
    /**
     * Shows button-icon responsible for closing inline-message
     */
    set closable(value) {
      this.element.nativeElement.closable = value;
    }
    get closable() {
      return this.element.nativeElement.closable;
    }
    /**
     * Emits when close button is clicked.
     */
    chrClose = new EventEmitter();
    static ɵfac = function ChrInlineMessageDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrInlineMessageDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrInlineMessageDirective,
      selectors: [["chr-inline-message"]],
      inputs: {
        palette: "palette",
        title: "title",
        closable: "closable"
      },
      outputs: {
        chrClose: "chr-close"
      }
    });
  }
  return ChrInlineMessageDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrInputDirective = /*#__PURE__*/(() => {
  class ChrInputDirective {
    element;
    previousValue;
    constructor(element) {
      this.element = element;
    }
    /**
     * Size of the input
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * Marks input as disabled
     */
    set disabled(value) {
      this.element.nativeElement.disabled = value;
    }
    get disabled() {
      return this.element.nativeElement.disabled;
    }
    /**
     * Mark input as required to be filled before submitting the form
     */
    set required(value) {
      this.element.nativeElement.required = value;
    }
    get required() {
      return this.element.nativeElement.required;
    }
    /**
     * Mark the input as readonly
     */
    set readonly(value) {
      this.element.nativeElement.readonly = value;
    }
    get readonly() {
      return this.element.nativeElement.readonly;
    }
    /**
     * Inputs value
     */
    set value(value) {
      this.element.nativeElement.value = value;
    }
    get value() {
      return this.element.nativeElement.value;
    }
    /**
     * Input name
     */
    set name(value) {
      this.element.nativeElement.name = value;
    }
    get name() {
      return this.element.nativeElement.name;
    }
    /**
     * Input type
     */
    set type(value) {
      this.element.nativeElement.type = value;
    }
    get type() {
      return this.element.nativeElement.type;
    }
    /**
     * Allows the browser to suggest or remember previously entered values.
     */
    set autocomplete(value) {
      this.element.nativeElement.autocomplete = value;
    }
    get autocomplete() {
      return this.element.nativeElement.autocomplete;
    }
    /**
     * Inputs placeholder
     */
    set placeholder(value) {
      this.element.nativeElement.placeholder = value;
    }
    get placeholder() {
      return this.element.nativeElement.placeholder;
    }
    /**
     * Whether input should display button for clearing the inputs value.
     */
    set clearable(value) {
      this.element.nativeElement.clearable = value;
    }
    get clearable() {
      return this.element.nativeElement.clearable;
    }
    /**
     * Prepending icon, if using CIPHR default icon set.
     * If you need to add icon outside of CIPHR icon set or anything else, please
     * use &#x60;icon&#x60; named slot.
     */
    set icon(value) {
      this.element.nativeElement.icon = value;
    }
    get icon() {
      return this.element.nativeElement.icon;
    }
    /**
     * Appending suffix for the field.
     * If you need to insert formatted text, or anything else, please use &#x60;suffix&#x60;
     * named slot instead.
     */
    set suffix(value) {
      this.element.nativeElement.suffix = value;
    }
    get suffix() {
      return this.element.nativeElement.suffix;
    }
    /**
     * Marks component as a valid
     */
    set success(value) {
      this.element.nativeElement.success = value;
    }
    get success() {
      return this.element.nativeElement.success;
    }
    /**
     * Marks component as not valid
     */
    set error(value) {
      this.element.nativeElement.error = value;
    }
    get error() {
      return this.element.nativeElement.error;
    }
    /**
     * Marks component as conditionally valid
     */
    set warning(value) {
      this.element.nativeElement.warning = value;
    }
    get warning() {
      return this.element.nativeElement.warning;
    }
    /**
     * Validation message - success, error or warning
     */
    set explicitValidationMessage(value) {
      this.element.nativeElement.explicitValidationMessage = value;
    }
    get explicitValidationMessage() {
      return this.element.nativeElement.explicitValidationMessage;
    }
    /**
     * Field name for screen readers. This should be used only when field is used without chr-label element.
     */
    set explicitLabel(value) {
      this.element.nativeElement.explicitLabel = value;
    }
    get explicitLabel() {
      return this.element.nativeElement.explicitLabel;
    }
    /**
     * Field description for screen readers. This should be used only when field is used without chr-label element.
     */
    set explicitDescription(value) {
      this.element.nativeElement.explicitDescription = value;
    }
    get explicitDescription() {
      return this.element.nativeElement.explicitDescription;
    }
    /**
     * Sets input value
     */
    set(value) {
      this.element.nativeElement.set(value);
    }
    /**
     * Clears input value
     */
    clear() {
      this.element.nativeElement.clear();
    }
    /**
     * Set the focus on a specific element
     */
    focus(options) {
      this.element.nativeElement.focus(options);
    }
    /**
     * Remove the focus from an element making it inactive
     */
    blur() {
      this.element.nativeElement.blur();
    }
    input = new EventEmitter();
    change = new EventEmitter();
    handleInput() {
      this.handleValueChange();
    }
    handleChange() {
      this.handleValueChange();
    }
    handleValueChange() {
      const currentValue = this.element.nativeElement.value;
      if (currentValue !== this.previousValue) {
        this.previousValue = currentValue;
        this.onChange(currentValue);
      }
    }
    onChange = () => {};
    onTouch = () => {};
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouch = fn;
    }
    writeValue(value) {
      this.element.nativeElement.value = value;
    }
    setDisabledState(disabled) {
      this.disabled = disabled;
    }
    static ɵfac = function ChrInputDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrInputDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrInputDirective,
      selectors: [["chr-input"]],
      hostBindings: function ChrInputDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("input", function ChrInputDirective_input_HostBindingHandler() {
            return ctx.handleInput();
          })("change", function ChrInputDirective_change_HostBindingHandler() {
            return ctx.handleChange();
          });
        }
      },
      inputs: {
        size: "size",
        disabled: "disabled",
        required: "required",
        readonly: "readonly",
        value: "value",
        name: "name",
        type: "type",
        autocomplete: "autocomplete",
        placeholder: "placeholder",
        clearable: "clearable",
        icon: "icon",
        suffix: "suffix",
        success: "success",
        error: "error",
        warning: "warning",
        explicitValidationMessage: [0, "validation-message", "explicitValidationMessage"],
        explicitLabel: [0, "label", "explicitLabel"],
        explicitDescription: [0, "description", "explicitDescription"]
      },
      outputs: {
        input: "input",
        change: "change"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ChrInputDirective),
        multi: true
      }])]
    });
  }
  return ChrInputDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrInputNumberDirective = /*#__PURE__*/(() => {
  class ChrInputNumberDirective {
    element;
    previousValue;
    constructor(element) {
      this.element = element;
    }
    /**
     * Min value that can be provided
     */
    set min(value) {
      this.element.nativeElement.min = value;
    }
    get min() {
      return this.element.nativeElement.min;
    }
    /**
     * Max value that can be provided
     */
    set max(value) {
      this.element.nativeElement.max = value;
    }
    get max() {
      return this.element.nativeElement.max;
    }
    /**
     * Marks component as a valid
     */
    set success(value) {
      this.element.nativeElement.success = value;
    }
    get success() {
      return this.element.nativeElement.success;
    }
    /**
     * Marks component as not valid
     */
    set error(value) {
      this.element.nativeElement.error = value;
    }
    get error() {
      return this.element.nativeElement.error;
    }
    /**
     * Marks component as conditionally valid
     */
    set warning(value) {
      this.element.nativeElement.warning = value;
    }
    get warning() {
      return this.element.nativeElement.warning;
    }
    /**
     * Validation message - success, error or warning
     */
    set explicitValidationMessage(value) {
      this.element.nativeElement.explicitValidationMessage = value;
    }
    get explicitValidationMessage() {
      return this.element.nativeElement.explicitValidationMessage;
    }
    /**
     * Field name for screen readers. This should be used only when field is used without chr-label element.
     */
    set explicitLabel(value) {
      this.element.nativeElement.explicitLabel = value;
    }
    get explicitLabel() {
      return this.element.nativeElement.explicitLabel;
    }
    /**
     * Field description for screen readers. This should be used only when field is used without chr-label element.
     */
    set explicitDescription(value) {
      this.element.nativeElement.explicitDescription = value;
    }
    get explicitDescription() {
      return this.element.nativeElement.explicitDescription;
    }
    /**
     * Size of the input
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * Marks input as disabled
     */
    set disabled(value) {
      this.element.nativeElement.disabled = value;
    }
    get disabled() {
      return this.element.nativeElement.disabled;
    }
    /**
     * Mark input as required to be filled before submitting the form
     */
    set required(value) {
      this.element.nativeElement.required = value;
    }
    get required() {
      return this.element.nativeElement.required;
    }
    /**
     * Mark the input as readonly
     */
    set readonly(value) {
      this.element.nativeElement.readonly = value;
    }
    get readonly() {
      return this.element.nativeElement.readonly;
    }
    /**
     * Inputs value
     */
    set value(value) {
      this.element.nativeElement.value = value;
    }
    get value() {
      return this.element.nativeElement.value;
    }
    /**
     * Input name
     */
    set name(value) {
      this.element.nativeElement.name = value;
    }
    get name() {
      return this.element.nativeElement.name;
    }
    /**
     * Input type
     */
    set type(value) {
      this.element.nativeElement.type = value;
    }
    get type() {
      return this.element.nativeElement.type;
    }
    /**
     * Allows the browser to suggest or remember previously entered values.
     */
    set autocomplete(value) {
      this.element.nativeElement.autocomplete = value;
    }
    get autocomplete() {
      return this.element.nativeElement.autocomplete;
    }
    /**
     * Inputs placeholder
     */
    set placeholder(value) {
      this.element.nativeElement.placeholder = value;
    }
    get placeholder() {
      return this.element.nativeElement.placeholder;
    }
    /**
     * Whether input should display button for clearing the inputs value.
     */
    set clearable(value) {
      this.element.nativeElement.clearable = value;
    }
    get clearable() {
      return this.element.nativeElement.clearable;
    }
    /**
     * Prepending icon, if using CIPHR default icon set.
     * If you need to add icon outside of CIPHR icon set or anything else, please
     * use &#x60;icon&#x60; named slot.
     */
    set icon(value) {
      this.element.nativeElement.icon = value;
    }
    get icon() {
      return this.element.nativeElement.icon;
    }
    /**
     * Appending suffix for the field.
     * If you need to insert formatted text, or anything else, please use &#x60;suffix&#x60;
     * named slot instead.
     */
    set suffix(value) {
      this.element.nativeElement.suffix = value;
    }
    get suffix() {
      return this.element.nativeElement.suffix;
    }
    /**
     * Set the focus on a specific element
     */
    focus(options) {
      this.element.nativeElement.focus(options);
    }
    /**
     * Remove the focus from an element making it inactive
     */
    blur() {
      this.element.nativeElement.blur();
    }
    /**
     * Sets input value
     */
    set(value) {
      this.element.nativeElement.set(value);
    }
    /**
     * Clears input value
     */
    clear() {
      this.element.nativeElement.clear();
    }
    input = new EventEmitter();
    change = new EventEmitter();
    handleInput() {
      this.handleValueChange();
    }
    handleChange() {
      this.handleValueChange();
    }
    handleValueChange() {
      const currentValue = this.element.nativeElement.value;
      if (currentValue !== this.previousValue) {
        this.previousValue = currentValue;
        this.onChange(currentValue);
      }
    }
    onChange = () => {};
    onTouch = () => {};
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouch = fn;
    }
    writeValue(value) {
      this.element.nativeElement.value = value;
    }
    setDisabledState(disabled) {
      this.disabled = disabled;
    }
    static ɵfac = function ChrInputNumberDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrInputNumberDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrInputNumberDirective,
      selectors: [["chr-input-number"]],
      hostBindings: function ChrInputNumberDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("input", function ChrInputNumberDirective_input_HostBindingHandler() {
            return ctx.handleInput();
          })("change", function ChrInputNumberDirective_change_HostBindingHandler() {
            return ctx.handleChange();
          });
        }
      },
      inputs: {
        min: "min",
        max: "max",
        success: "success",
        error: "error",
        warning: "warning",
        explicitValidationMessage: [0, "validation-message", "explicitValidationMessage"],
        explicitLabel: [0, "label", "explicitLabel"],
        explicitDescription: [0, "description", "explicitDescription"],
        size: "size",
        disabled: "disabled",
        required: "required",
        readonly: "readonly",
        value: "value",
        name: "name",
        type: "type",
        autocomplete: "autocomplete",
        placeholder: "placeholder",
        clearable: "clearable",
        icon: "icon",
        suffix: "suffix"
      },
      outputs: {
        input: "input",
        change: "change"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ChrInputNumberDirective),
        multi: true
      }])]
    });
  }
  return ChrInputNumberDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrInputPasswordDirective = /*#__PURE__*/(() => {
  class ChrInputPasswordDirective {
    element;
    previousValue;
    constructor(element) {
      this.element = element;
    }
    /**
     * Input-password value
     */
    set value(value) {
      this.element.nativeElement.value = value;
    }
    get value() {
      return this.element.nativeElement.value;
    }
    /**
     * Allows the browser to suggest or remember previously entered values.
     */
    set autocomplete(value) {
      this.element.nativeElement.autocomplete = value;
    }
    get autocomplete() {
      return this.element.nativeElement.autocomplete;
    }
    /**
     * Marks component as a valid
     */
    set success(value) {
      this.element.nativeElement.success = value;
    }
    get success() {
      return this.element.nativeElement.success;
    }
    /**
     * Marks component as not valid
     */
    set error(value) {
      this.element.nativeElement.error = value;
    }
    get error() {
      return this.element.nativeElement.error;
    }
    /**
     * Marks component as conditionally valid
     */
    set warning(value) {
      this.element.nativeElement.warning = value;
    }
    get warning() {
      return this.element.nativeElement.warning;
    }
    /**
     * Validation message - success, error or warning
     */
    set explicitValidationMessage(value) {
      this.element.nativeElement.explicitValidationMessage = value;
    }
    get explicitValidationMessage() {
      return this.element.nativeElement.explicitValidationMessage;
    }
    /**
     * Field name for screen readers. This should be used only when field is used without chr-label element.
     */
    set explicitLabel(value) {
      this.element.nativeElement.explicitLabel = value;
    }
    get explicitLabel() {
      return this.element.nativeElement.explicitLabel;
    }
    /**
     * Field description for screen readers. This should be used only when field is used without chr-label element.
     */
    set explicitDescription(value) {
      this.element.nativeElement.explicitDescription = value;
    }
    get explicitDescription() {
      return this.element.nativeElement.explicitDescription;
    }
    /**
     * Size of the input
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * Marks input as disabled
     */
    set disabled(value) {
      this.element.nativeElement.disabled = value;
    }
    get disabled() {
      return this.element.nativeElement.disabled;
    }
    /**
     * Mark input as required to be filled before submitting the form
     */
    set required(value) {
      this.element.nativeElement.required = value;
    }
    get required() {
      return this.element.nativeElement.required;
    }
    /**
     * Mark the input as readonly
     */
    set readonly(value) {
      this.element.nativeElement.readonly = value;
    }
    get readonly() {
      return this.element.nativeElement.readonly;
    }
    /**
     * Input name
     */
    set name(value) {
      this.element.nativeElement.name = value;
    }
    get name() {
      return this.element.nativeElement.name;
    }
    /**
     * Input type
     */
    set type(value) {
      this.element.nativeElement.type = value;
    }
    get type() {
      return this.element.nativeElement.type;
    }
    /**
     * Inputs placeholder
     */
    set placeholder(value) {
      this.element.nativeElement.placeholder = value;
    }
    get placeholder() {
      return this.element.nativeElement.placeholder;
    }
    /**
     * Whether input should display button for clearing the inputs value.
     */
    set clearable(value) {
      this.element.nativeElement.clearable = value;
    }
    get clearable() {
      return this.element.nativeElement.clearable;
    }
    /**
     * Prepending icon, if using CIPHR default icon set.
     * If you need to add icon outside of CIPHR icon set or anything else, please
     * use &#x60;icon&#x60; named slot.
     */
    set icon(value) {
      this.element.nativeElement.icon = value;
    }
    get icon() {
      return this.element.nativeElement.icon;
    }
    /**
     * Appending suffix for the field.
     * If you need to insert formatted text, or anything else, please use &#x60;suffix&#x60;
     * named slot instead.
     */
    set suffix(value) {
      this.element.nativeElement.suffix = value;
    }
    get suffix() {
      return this.element.nativeElement.suffix;
    }
    /**
     * Set the focus on a specific element
     */
    focus(options) {
      this.element.nativeElement.focus(options);
    }
    /**
     * Remove the focus from an element making it inactive
     */
    blur() {
      this.element.nativeElement.blur();
    }
    /**
     * Sets input value
     */
    set(value) {
      this.element.nativeElement.set(value);
    }
    /**
     * Clears input value
     */
    clear() {
      this.element.nativeElement.clear();
    }
    input = new EventEmitter();
    change = new EventEmitter();
    handleInput() {
      this.handleValueChange();
    }
    handleChange() {
      this.handleValueChange();
    }
    handleValueChange() {
      const currentValue = this.element.nativeElement.value;
      if (currentValue !== this.previousValue) {
        this.previousValue = currentValue;
        this.onChange(currentValue);
      }
    }
    onChange = () => {};
    onTouch = () => {};
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouch = fn;
    }
    writeValue(value) {
      this.element.nativeElement.value = value;
    }
    setDisabledState(disabled) {
      this.disabled = disabled;
    }
    static ɵfac = function ChrInputPasswordDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrInputPasswordDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrInputPasswordDirective,
      selectors: [["chr-input-password"]],
      hostBindings: function ChrInputPasswordDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("input", function ChrInputPasswordDirective_input_HostBindingHandler() {
            return ctx.handleInput();
          })("change", function ChrInputPasswordDirective_change_HostBindingHandler() {
            return ctx.handleChange();
          });
        }
      },
      inputs: {
        value: "value",
        autocomplete: "autocomplete",
        success: "success",
        error: "error",
        warning: "warning",
        explicitValidationMessage: [0, "validation-message", "explicitValidationMessage"],
        explicitLabel: [0, "label", "explicitLabel"],
        explicitDescription: [0, "description", "explicitDescription"],
        size: "size",
        disabled: "disabled",
        required: "required",
        readonly: "readonly",
        name: "name",
        type: "type",
        placeholder: "placeholder",
        clearable: "clearable",
        icon: "icon",
        suffix: "suffix"
      },
      outputs: {
        input: "input",
        change: "change"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ChrInputPasswordDirective),
        multi: true
      }])]
    });
  }
  return ChrInputPasswordDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrLabelDirective = /*#__PURE__*/(() => {
  class ChrLabelDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Label size
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * Adds (required) in the end of label, that indicates that field is required.
     */
    set required(value) {
      this.element.nativeElement.required = value;
    }
    get required() {
      return this.element.nativeElement.required;
    }
    onChange = () => {};
    onTouch = () => {};
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouch = fn;
    }
    writeValue(value) {
      this.element.nativeElement.value = value;
    }
    static ɵfac = function ChrLabelDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrLabelDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrLabelDirective,
      selectors: [["chr-label"]],
      inputs: {
        size: "size",
        required: "required"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ChrLabelDirective),
        multi: true
      }])]
    });
  }
  return ChrLabelDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrMenuDirective = /*#__PURE__*/(() => {
  class ChrMenuDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Event that is emitted when any of the children &#x60;&lt;chr-nav-item&gt;&#x60; is selected.
     */
    chrItemSelected = new EventEmitter();
    static ɵfac = function ChrMenuDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrMenuDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrMenuDirective,
      selectors: [["chr-menu"]],
      outputs: {
        chrItemSelected: "chr-item-selected"
      }
    });
  }
  return ChrMenuDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrMenuOverlayDirective = /*#__PURE__*/(() => {
  class ChrMenuOverlayDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Where menu should be placed
     */
    set placement(value) {
      this.element.nativeElement.placement = value;
    }
    get placement() {
      return this.element.nativeElement.placement;
    }
    /**
     * defines popover id of the menu. Thi should match with &#x60;chrpopover&#x3D;&quot;popover-id&quot;&#x60; on the trigger element.
     */
    set menuId(value) {
      this.element.nativeElement.menuId = value;
    }
    get menuId() {
      return this.element.nativeElement.menuId;
    }
    /**
     * Whether opening menu on click should be prevented, so that custom opening action can be provided.
     */
    set preventOpen(value) {
      this.element.nativeElement.preventOpen = value;
    }
    get preventOpen() {
      return this.element.nativeElement.preventOpen;
    }
    /**
     * Sets menu-overlay as visible
     */
    open(payload) {
      this.element.nativeElement.open(payload);
    }
    /**
     * Sets menu-overlay as invisible
     */
    close(payload) {
      this.element.nativeElement.close(payload);
    }
    /**
     * Toggles menu-overlay visibility
     */
    toggle() {
      this.element.nativeElement.toggle();
    }
    /**
     * Event emitted on method call, before overlay is attached to body.
     */
    chrOpen = new EventEmitter();
    /**
     * Event emitted after overlay is open and is placed in new position on top of everything.
     */
    chrOpened = new EventEmitter();
    /**
     * Event emitted on &#x60;close()&#x60; method call, before it is restored to its previous position.
     */
    chrClose = new EventEmitter();
    /**
     * Event emitted after overlay is actually closed and its position is restored to original place in DOM.
     */
    chrClosed = new EventEmitter();
    /**
     * Event emitted on clicking outside of overlay.
     */
    chrClickedOutside = new EventEmitter();
    static ɵfac = function ChrMenuOverlayDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrMenuOverlayDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrMenuOverlayDirective,
      selectors: [["chr-menu-overlay"]],
      inputs: {
        placement: "placement",
        menuId: [0, "menuid", "menuId"],
        preventOpen: [0, "preventopen", "preventOpen"]
      },
      outputs: {
        chrOpen: "chr-open",
        chrOpened: "chr-opened",
        chrClose: "chr-close",
        chrClosed: "chr-closed",
        chrClickedOutside: "chr-clicked-outside"
      }
    });
  }
  return ChrMenuOverlayDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrModalDirective = /*#__PURE__*/(() => {
  class ChrModalDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Define modal size
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * Define modal palette
     */
    set palette(value) {
      this.element.nativeElement.palette = value;
    }
    get palette() {
      return this.element.nativeElement.palette;
    }
    /**
     * Define if modal is opened or not
     */
    set opened(value) {
      this.element.nativeElement.opened = value;
    }
    get opened() {
      return this.element.nativeElement.opened;
    }
    /**
     * Shows icon-button responsible for closing modal
     */
    set closable(value) {
      this.element.nativeElement.closable = value;
    }
    get closable() {
      return this.element.nativeElement.closable;
    }
    /**
     * Emits when button is clicked and not disabled.
     */
    chrModalClose = new EventEmitter();
    static ɵfac = function ChrModalDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrModalDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrModalDirective,
      selectors: [["chr-modal"]],
      inputs: {
        size: "size",
        palette: "palette",
        opened: [0, "open", "opened"],
        closable: "closable"
      },
      outputs: {
        chrModalClose: "chr-modal-close"
      }
    });
  }
  return ChrModalDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrModalBodyDirective = /*#__PURE__*/(() => {
  class ChrModalBodyDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    static ɵfac = function ChrModalBodyDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrModalBodyDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrModalBodyDirective,
      selectors: [["chr-modal-body"]]
    });
  }
  return ChrModalBodyDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrModalFooterDirective = /*#__PURE__*/(() => {
  class ChrModalFooterDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Define palette for elements inside
     */
    set palette(value) {
      this.element.nativeElement.palette = value;
    }
    get palette() {
      return this.element.nativeElement.palette;
    }
    static ɵfac = function ChrModalFooterDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrModalFooterDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrModalFooterDirective,
      selectors: [["chr-modal-footer"]],
      inputs: {
        palette: "palette"
      }
    });
  }
  return ChrModalFooterDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrModalHeaderDirective = /*#__PURE__*/(() => {
  class ChrModalHeaderDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Modal-header title
     */
    set title(value) {
      this.element.nativeElement.title = value;
    }
    get title() {
      return this.element.nativeElement.title;
    }
    /**
     * Define modal-header palette
     */
    set palette(value) {
      this.element.nativeElement.palette = value;
    }
    get palette() {
      return this.element.nativeElement.palette;
    }
    /**
     * Shows icon specified for each palette if sets to true
     */
    set withIcon(value) {
      this.element.nativeElement.withIcon = value;
    }
    get withIcon() {
      return this.element.nativeElement.withIcon;
    }
    static ɵfac = function ChrModalHeaderDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrModalHeaderDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrModalHeaderDirective,
      selectors: [["chr-modal-header"]],
      inputs: {
        title: "title",
        palette: "palette",
        withIcon: [0, "with-icon", "withIcon"]
      }
    });
  }
  return ChrModalHeaderDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrModalOverlayDirective = /*#__PURE__*/(() => {
  class ChrModalOverlayDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Sets modal as visible
     */
    open(payload) {
      this.element.nativeElement.open(payload);
    }
    /**
     * Sets modal as invisible
     */
    close(payload) {
      this.element.nativeElement.close(payload);
    }
    /**
     * Emits when modal-overlay is opening.
     */
    chrOpen = new EventEmitter();
    /**
     * Emits when modal-overlay is opened.
     */
    chrOpened = new EventEmitter();
    /**
     * Emits when modal-overlay is closing.
     */
    chrClose = new EventEmitter();
    /**
     * Emits when modal-overlay is closed.
     */
    chrClosed = new EventEmitter();
    /**
     * Emits when user clicks outside the modal.
     */
    chrClickedOutside = new EventEmitter();
    static ɵfac = function ChrModalOverlayDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrModalOverlayDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrModalOverlayDirective,
      selectors: [["chr-modal-overlay"]],
      outputs: {
        chrOpen: "chr-open",
        chrOpened: "chr-opened",
        chrClose: "chr-close",
        chrClosed: "chr-closed",
        chrClickedOutside: "chr-clicked-outside"
      }
    });
  }
  return ChrModalOverlayDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrMultiSelectDirective = /*#__PURE__*/(() => {
  class ChrMultiSelectDirective {
    element;
    previousValue;
    constructor(element) {
      this.element = element;
    }
    /**
     * Size of the multi-select.
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * Marks the multi-select as disabled.
     */
    set disabled(value) {
      this.element.nativeElement.disabled = value;
    }
    get disabled() {
      return this.element.nativeElement.disabled;
    }
    /**
     * Mark the multiselect as readonly
     */
    set readonly(value) {
      this.element.nativeElement.readonly = value;
    }
    get readonly() {
      return this.element.nativeElement.readonly;
    }
    /**
     * The multi-selects value.
     * It stores the values of each of the selected options, passed in as payload.
     * Providing an empty array will select no options.
     */
    set value(value) {
      this.element.nativeElement.value = value;
    }
    get value() {
      return this.element.nativeElement.value;
    }
    /**
     * The multi-selects placeholder.
     */
    set placeholder(value) {
      this.element.nativeElement.placeholder = value;
    }
    get placeholder() {
      return this.element.nativeElement.placeholder;
    }
    /**
     * Marks component as a valid
     */
    set success(value) {
      this.element.nativeElement.success = value;
    }
    get success() {
      return this.element.nativeElement.success;
    }
    /**
     * Marks component as not valid
     */
    set error(value) {
      this.element.nativeElement.error = value;
    }
    get error() {
      return this.element.nativeElement.error;
    }
    /**
     * Marks component as conditionally valid
     */
    set warning(value) {
      this.element.nativeElement.warning = value;
    }
    get warning() {
      return this.element.nativeElement.warning;
    }
    /**
     * Validation message - success, error or warning
     */
    set explicitValidationMessage(value) {
      this.element.nativeElement.explicitValidationMessage = value;
    }
    get explicitValidationMessage() {
      return this.element.nativeElement.explicitValidationMessage;
    }
    /**
     * Opens dropdown with provided options
     */
    open() {
      this.element.nativeElement.open();
    }
    /**
     * Closes dropdown with provided options
     */
    close() {
      this.element.nativeElement.close();
    }
    /**
     * Sets multi-select value
     */
    set(value) {
      this.element.nativeElement.set(value);
    }
    /**
     * Clears multi-select value
     */
    clear() {
      this.element.nativeElement.clear();
    }
    /**
     * Set the focus on a specific element
     */
    focus(options) {
      this.element.nativeElement.focus(options);
    }
    /**
     * Remove the focus from an element making it inactive
     */
    blur() {
      this.element.nativeElement.blur();
    }
    change = new EventEmitter();
    handleChange() {
      this.handleValueChange();
    }
    handleValueChange() {
      const currentValue = this.element.nativeElement.value;
      if (currentValue !== this.previousValue) {
        this.previousValue = currentValue;
        this.onChange(currentValue);
      }
    }
    onChange = () => {};
    onTouch = () => {};
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouch = fn;
    }
    writeValue(value) {
      this.element.nativeElement.value = value;
    }
    setDisabledState(disabled) {
      this.disabled = disabled;
    }
    static ɵfac = function ChrMultiSelectDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrMultiSelectDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrMultiSelectDirective,
      selectors: [["chr-multi-select"]],
      hostBindings: function ChrMultiSelectDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("change", function ChrMultiSelectDirective_change_HostBindingHandler() {
            return ctx.handleChange();
          });
        }
      },
      inputs: {
        size: "size",
        disabled: "disabled",
        readonly: "readonly",
        value: "value",
        placeholder: "placeholder",
        success: "success",
        error: "error",
        warning: "warning",
        explicitValidationMessage: [0, "validation-message", "explicitValidationMessage"]
      },
      outputs: {
        change: "change"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ChrMultiSelectDirective),
        multi: true
      }])]
    });
  }
  return ChrMultiSelectDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrNavGroupDirective = /*#__PURE__*/(() => {
  class ChrNavGroupDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Icon displayed in the side-nav representing a nav-group.
     */
    set icon(value) {
      this.element.nativeElement.icon = value;
    }
    get icon() {
      return this.element.nativeElement.icon;
    }
    /**
     * Label displayed as both the drawer heading and the title of the nav-group.
     */
    set label(value) {
      this.element.nativeElement.label = value;
    }
    get label() {
      return this.element.nativeElement.label;
    }
    /**
     * Short label displayed below nav-group icon.
     */
    set shortLabel(value) {
      this.element.nativeElement.shortLabel = value;
    }
    get shortLabel() {
      return this.element.nativeElement.shortLabel;
    }
    /**
     * Describes nav-group color palette
     */
    set palette(value) {
      this.element.nativeElement.palette = value;
    }
    get palette() {
      return this.element.nativeElement.palette;
    }
    /**
     * URL which nav-group will redirect to if provided
     */
    set href(value) {
      this.element.nativeElement.href = value;
    }
    get href() {
      return this.element.nativeElement.href;
    }
    /**
     * Indicates where to display the linked URL, as the name for a browsing context (a tab, window, or &lt;iframe&gt;).
     */
    set target(value) {
      this.element.nativeElement.target = value;
    }
    get target() {
      return this.element.nativeElement.target;
    }
    /**
     * Marks nav-group as active.
     * Active nav-group will display a visible drawer.
     * No nav-item is marked as selected in this state.
     */
    set active(value) {
      this.element.nativeElement.active = value;
    }
    get active() {
      return this.element.nativeElement.active;
    }
    /**
     * Marks nav-group as selected.
     * It indicates that the nav-group or one of the associated nav-items has been selected.
     */
    set selected(value) {
      this.element.nativeElement.selected = value;
    }
    get selected() {
      return this.element.nativeElement.selected;
    }
    /**
     * Determines whether the logo slotted in the side-nav should be visible or not in the nav-group drawer.
     */
    set hideLogo(value) {
      this.element.nativeElement.hideLogo = value;
    }
    get hideLogo() {
      return this.element.nativeElement.hideLogo;
    }
    /**
     * Marks nav-group as disabled
     */
    set disabled(value) {
      this.element.nativeElement.disabled = value;
    }
    get disabled() {
      return this.element.nativeElement.disabled;
    }
    /**
     * Prevent setting nav-group as selected.
     */
    set stateless(value) {
      this.element.nativeElement.stateless = value;
    }
    get stateless() {
      return this.element.nativeElement.stateless;
    }
    /**
     * Sets nav-group as active.
     * Built-in nav-item representing the nav-group will be indicated as active, and the drawer will be shown.
     */
    activate() {
      this.element.nativeElement.activate();
    }
    /**
     * Sets nav-group as inactive.
     * Built-in nav-item representing the nav-group will be indicated as inactive, and the drawer will be hidden.
     */
    deactivate() {
      this.element.nativeElement.deactivate();
    }
    /**
     * Returns information about whether the nav-group is active or not.
     */
    isActive() {
      this.element.nativeElement.isActive();
    }
    /**
     * Sets nav-group as selected.
     * Built-in nav-item representing the nav-group will be indicated as selected.
     */
    select() {
      this.element.nativeElement.select();
    }
    /**
     * Sets nav-group as not selected.
     * Built-in nav-item representing the nav-group will be indicated as default.
     */
    deselect() {
      this.element.nativeElement.deselect();
    }
    /**
     * Returns information about whether the nav-group is selected or not.
     */
    isSelected() {
      this.element.nativeElement.isSelected();
    }
    /**
     * Emits when nav-group is clicked. It emits nav-group as event detail.
     */
    chrAction = new EventEmitter();
    /**
     * Emits when nav-group active property changed. It emits active value as event detail.
     */
    chrActive = new EventEmitter();
    /**
     * Emits when nav-group&#x27;s selected property is changed. Nav-group and selected property value will be emitted in the event detail.
     */
    chrSelected = new EventEmitter();
    static ɵfac = function ChrNavGroupDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrNavGroupDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrNavGroupDirective,
      selectors: [["chr-nav-group"]],
      inputs: {
        icon: "icon",
        label: "label",
        shortLabel: [0, "short-label", "shortLabel"],
        palette: "palette",
        href: "href",
        target: "target",
        active: "active",
        selected: "selected",
        hideLogo: [0, "hide-logo", "hideLogo"],
        disabled: "disabled",
        stateless: "stateless"
      },
      outputs: {
        chrAction: "chr-action",
        chrActive: "chr-active",
        chrSelected: "chr-selected"
      }
    });
  }
  return ChrNavGroupDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrNavItemDirective = /*#__PURE__*/(() => {
  class ChrNavItemDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Size of the nav-item
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * Nav-item variant
     */
    set variant(value) {
      this.element.nativeElement.variant = value;
    }
    get variant() {
      return this.element.nativeElement.variant;
    }
    /**
     * Describes nav-item color palette
     */
    set palette(value) {
      this.element.nativeElement.palette = value;
    }
    get palette() {
      return this.element.nativeElement.palette;
    }
    /**
     * Marks nav-item as selected
     */
    set selected(value) {
      this.element.nativeElement.selected = value;
    }
    get selected() {
      return this.element.nativeElement.selected;
    }
    /**
     * Marks nav-item as disabled
     */
    set disabled(value) {
      this.element.nativeElement.disabled = value;
    }
    get disabled() {
      return this.element.nativeElement.disabled;
    }
    /**
     * Marks nav-item to shows icon only if set to true (slot-before)
     * Label, description and slot-after are hidden
     */
    set compact(value) {
      this.element.nativeElement.compact = value;
    }
    get compact() {
      return this.element.nativeElement.compact;
    }
    /**
     * Label of the nav-item
     * It&#x27;s hidden when icon-only is set to true
     */
    set label(value) {
      this.element.nativeElement.label = value;
    }
    get label() {
      return this.element.nativeElement.label;
    }
    /**
     * URL which nav-item will redirect to if provided
     */
    set href(value) {
      this.element.nativeElement.href = value;
    }
    get href() {
      return this.element.nativeElement.href;
    }
    /**
     * Indicates where to display the linked URL, as the name for a browsing context (a tab, window, or &lt;iframe&gt;).
     */
    set target(value) {
      this.element.nativeElement.target = value;
    }
    get target() {
      return this.element.nativeElement.target;
    }
    /**
     * Additional description of the nav-item
     * It&#x27;s hidden when label it&#x27;s not provided or icon-only is set to true
     */
    set description(value) {
      this.element.nativeElement.description = value;
    }
    get description() {
      return this.element.nativeElement.description;
    }
    /**
     * Will be emitted as detail payload of actionEvent.
     */
    set value(value) {
      this.element.nativeElement.value = value;
    }
    get value() {
      return this.element.nativeElement.value;
    }
    /**
     * Prepending icon, if using CIPHR default icon set.
     * If you need to add icon outside of CIPHR icon set or anything else, please
     * use &#x60;icon&#x60; named slot.
     */
    set icon(value) {
      this.element.nativeElement.icon = value;
    }
    get icon() {
      return this.element.nativeElement.icon;
    }
    /**
     * Sets nav-item selected property to true.
     */
    select() {
      this.element.nativeElement.select();
    }
    /**
     * Sets nav-item selected property to false.
     */
    deselect() {
      this.element.nativeElement.deselect();
    }
    /**
     * Returns information about whether the nav-item is selected or not.
     */
    isSelected() {
      this.element.nativeElement.isSelected();
    }
    /**
     * Set the focus on a specific element
     */
    focus(options) {
      this.element.nativeElement.focus(options);
    }
    /**
     * Remove the focus from an element making it inactive
     */
    blur() {
      this.element.nativeElement.blur();
    }
    /**
     * Emits when nav-item is clicked. Nav-item payload will be emitted in the event detail.
     */
    chrAction = new EventEmitter();
    /**
     * Emits when nav-item is set as selected. Nav-item will be emitted in the event detail.
     */
    chrSelected = new EventEmitter();
    static ɵfac = function ChrNavItemDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrNavItemDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrNavItemDirective,
      selectors: [["chr-nav-item"]],
      inputs: {
        size: "size",
        variant: "variant",
        palette: "palette",
        selected: "selected",
        disabled: "disabled",
        compact: "compact",
        label: "label",
        href: "href",
        target: "target",
        description: "description",
        value: [0, "payload", "value"],
        icon: "icon"
      },
      outputs: {
        chrAction: "chr-action",
        chrSelected: "chr-selected"
      }
    });
  }
  return ChrNavItemDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrNavTreeDirective = /*#__PURE__*/(() => {
  class ChrNavTreeDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Describes nav-tree color palette
     */
    set palette(value) {
      this.element.nativeElement.palette = value;
    }
    get palette() {
      return this.element.nativeElement.palette;
    }
    /**
     * Label of collapsible nav-tree.
     */
    set label(value) {
      this.element.nativeElement.label = value;
    }
    get label() {
      return this.element.nativeElement.label;
    }
    /**
     * Prepending icon, if using CIPHR default icon set.
     */
    set icon(value) {
      this.element.nativeElement.icon = value;
    }
    get icon() {
      return this.element.nativeElement.icon;
    }
    /**
     * Toggles nav-tree content visibility.
     */
    set opened(value) {
      this.element.nativeElement.opened = value;
    }
    get opened() {
      return this.element.nativeElement.opened;
    }
    /**
     * Sets nav-group as selected.
     * It indicates that one of the nested nav-items has been selected.
     */
    set selected(value) {
      this.element.nativeElement.selected = value;
    }
    get selected() {
      return this.element.nativeElement.selected;
    }
    /**
     * Indicates if the nav-tree should be scrolled to be visible in the viewport.
     */
    set autoScroll(value) {
      this.element.nativeElement.autoScroll = value;
    }
    get autoScroll() {
      return this.element.nativeElement.autoScroll;
    }
    /**
     * Sets nav-tree as selected.
     * Built-in nav-item representing the nav-tree will be indicated as selected.
     */
    select() {
      this.element.nativeElement.select();
    }
    /**
     * Sets nav-tree as not selected.
     * Built-in nav-item representing the nav-tree will be indicated as default.
     */
    deselect() {
      this.element.nativeElement.deselect();
    }
    /**
     * Returns information about whether the nav-tree is selected or not.
     */
    isSelected() {
      this.element.nativeElement.isSelected();
    }
    /**
     * Expands the navigation tree, making all its nodes visible.
     */
    open() {
      this.element.nativeElement.open();
    }
    /**
     * Collapses the navigation tree, hiding its nodes.
     */
    close() {
      this.element.nativeElement.close();
    }
    /**
     * Emits when nav-tree opened property changed to true. Component will be emitted in event detail.
     */
    chrOpened = new EventEmitter();
    static ɵfac = function ChrNavTreeDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrNavTreeDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrNavTreeDirective,
      selectors: [["chr-nav-tree"]],
      inputs: {
        palette: "palette",
        label: "label",
        icon: "icon",
        opened: "opened",
        selected: "selected",
        autoScroll: [0, "auto-scroll", "autoScroll"]
      },
      outputs: {
        chrOpened: "chr-opened"
      }
    });
  }
  return ChrNavTreeDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrPaginationDirective = /*#__PURE__*/(() => {
  class ChrPaginationDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Display full size pagination if it&#x27;s set to false
     */
    set compact(value) {
      this.element.nativeElement.compact = value;
    }
    get compact() {
      return this.element.nativeElement.compact;
    }
    /**
     * Current page number
     */
    set current(value) {
      this.element.nativeElement.current = value;
    }
    get current() {
      return this.element.nativeElement.current;
    }
    /**
     * Total page number
     */
    set total(value) {
      this.element.nativeElement.total = value;
    }
    get total() {
      return this.element.nativeElement.total;
    }
    /**
     * Sets previous page as selected
     */
    prev() {
      this.element.nativeElement.prev();
    }
    /**
     * Sets next page as selected
     */
    next() {
      this.element.nativeElement.next();
    }
    /**
     * Sets provided page as selected
     */
    select(page) {
      this.element.nativeElement.select(page);
    }
    /**
     * Emits event when pagination page is changed.
     */
    chrPageSelected = new EventEmitter();
    static ɵfac = function ChrPaginationDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrPaginationDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrPaginationDirective,
      selectors: [["chr-pagination"]],
      inputs: {
        compact: "compact",
        current: "current",
        total: "total"
      },
      outputs: {
        chrPageSelected: "chr-page-selected"
      }
    });
  }
  return ChrPaginationDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrPillDirective = /*#__PURE__*/(() => {
  class ChrPillDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Pill size
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * Pill variant
     */
    set variant(value) {
      this.element.nativeElement.variant = value;
    }
    get variant() {
      return this.element.nativeElement.variant;
    }
    /**
     * Describes color palette of the pill
     */
    set palette(value) {
      this.element.nativeElement.palette = value;
    }
    get palette() {
      return this.element.nativeElement.palette;
    }
    /**
     * Display pill as dot (without visible value) if it&#x27;s set to true
     */
    set compact(value) {
      this.element.nativeElement.compact = value;
    }
    get compact() {
      return this.element.nativeElement.compact;
    }
    /**
     * Pill value
     */
    set value(value) {
      this.element.nativeElement.value = value;
    }
    get value() {
      return this.element.nativeElement.value;
    }
    static ɵfac = function ChrPillDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrPillDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrPillDirective,
      selectors: [["chr-pill"]],
      inputs: {
        size: "size",
        variant: "variant",
        palette: "palette",
        compact: "compact",
        value: "value"
      }
    });
  }
  return ChrPillDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrRadioDirective = /*#__PURE__*/(() => {
  class ChrRadioDirective {
    element;
    previousValue;
    constructor(element) {
      this.element = element;
    }
    /**
     * Size of the radio
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * Marks radio as selected
     */
    set checked(value) {
      this.element.nativeElement.checked = value;
    }
    get checked() {
      return this.element.nativeElement.checked;
    }
    /**
     * Marks radio as disabled
     */
    set disabled(value) {
      this.element.nativeElement.disabled = value;
    }
    get disabled() {
      return this.element.nativeElement.disabled;
    }
    /**
     * Mark radio as required to be selected before submitting the form
     */
    set required(value) {
      this.element.nativeElement.required = value;
    }
    get required() {
      return this.element.nativeElement.required;
    }
    /**
     * Mark radio as readonly
     */
    set readonly(value) {
      this.element.nativeElement.readonly = value;
    }
    get readonly() {
      return this.element.nativeElement.readonly;
    }
    /**
     * Radio name
     */
    set name(value) {
      this.element.nativeElement.name = value;
    }
    get name() {
      return this.element.nativeElement.name;
    }
    /**
     * Radio value
     */
    set value(value) {
      this.element.nativeElement.value = value;
    }
    get value() {
      return this.element.nativeElement.value;
    }
    /**
     * Marks radio as not valid
     */
    set error(value) {
      this.element.nativeElement.error = value;
    }
    get error() {
      return this.element.nativeElement.error;
    }
    /**
     * Sets 'checked' state for the radio
     */
    select() {
      this.element.nativeElement.select();
    }
    /**
     * Removes 'checked' state from the radio
     */
    deselect() {
      this.element.nativeElement.deselect();
    }
    /**
     * Sets provided state for the radio
     */
    set(value) {
      this.element.nativeElement.set(value);
    }
    /**
     * Clears radio state
     */
    clear() {
      this.element.nativeElement.clear();
    }
    /**
     * Set the focus on a specific element
     */
    focus(options) {
      this.element.nativeElement.focus(options);
    }
    /**
     * Remove the focus from an element making it inactive
     */
    blur() {
      this.element.nativeElement.blur();
    }
    change = new EventEmitter();
    handleChange() {
      this.handleValueChange();
    }
    handleValueChange() {
      const currentValue = this.element.nativeElement.value;
      this.onChange(currentValue);
    }
    onChange = () => {};
    onTouch = () => {};
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouch = fn;
    }
    writeValue(value) {
      this.element.nativeElement.checked = value === this.value;
    }
    setDisabledState(disabled) {
      this.disabled = disabled;
    }
    static ɵfac = function ChrRadioDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrRadioDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrRadioDirective,
      selectors: [["chr-radio"]],
      hostBindings: function ChrRadioDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("change", function ChrRadioDirective_change_HostBindingHandler() {
            return ctx.handleChange();
          });
        }
      },
      inputs: {
        size: "size",
        checked: "checked",
        disabled: "disabled",
        required: "required",
        readonly: "readonly",
        name: "name",
        value: "value",
        error: "error"
      },
      outputs: {
        change: "change"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ChrRadioDirective),
        multi: true
      }])]
    });
  }
  return ChrRadioDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrRadioGroupDirective = /*#__PURE__*/(() => {
  class ChrRadioGroupDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Size of the radio-group elements
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * Specifies layout direction of the radio within the group
     */
    set direction(value) {
      this.element.nativeElement.direction = value;
    }
    get direction() {
      return this.element.nativeElement.direction;
    }
    /**
     * Mark the radio-group as required.
     * Suggest that radio should be checked before submitting the form
     */
    set required(value) {
      this.element.nativeElement.required = value;
    }
    get required() {
      return this.element.nativeElement.required;
    }
    /**
     * Mark radios in radio-group as readonly
     */
    set readonly(value) {
      this.element.nativeElement.readonly = value;
    }
    get readonly() {
      return this.element.nativeElement.readonly;
    }
    /**
     * Marks radio-group as not valid
     */
    set error(value) {
      this.element.nativeElement.error = value;
    }
    get error() {
      return this.element.nativeElement.error;
    }
    /**
     * Set name for all radio inside radio-group
     */
    set name(value) {
      this.element.nativeElement.name = value;
    }
    get name() {
      return this.element.nativeElement.name;
    }
    /**
     * Marks component as a valid
     */
    set success(value) {
      this.element.nativeElement.success = value;
    }
    get success() {
      return this.element.nativeElement.success;
    }
    /**
     * Marks component as conditionally valid
     */
    set warning(value) {
      this.element.nativeElement.warning = value;
    }
    get warning() {
      return this.element.nativeElement.warning;
    }
    /**
     * Validation message - success, error or warning
     */
    set explicitValidationMessage(value) {
      this.element.nativeElement.explicitValidationMessage = value;
    }
    get explicitValidationMessage() {
      return this.element.nativeElement.explicitValidationMessage;
    }
    static ɵfac = function ChrRadioGroupDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrRadioGroupDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrRadioGroupDirective,
      selectors: [["chr-radio-group"]],
      inputs: {
        size: "size",
        direction: "direction",
        required: "required",
        readonly: "readonly",
        error: "error",
        name: "name",
        success: "success",
        warning: "warning",
        explicitValidationMessage: [0, "validation-message", "explicitValidationMessage"]
      }
    });
  }
  return ChrRadioGroupDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrRangeDatepickerDirective = /*#__PURE__*/(() => {
  class ChrRangeDatepickerDirective {
    element;
    previousValue;
    constructor(element) {
      this.element = element;
    }
    /**
     * Range-datepicker value in default dd/MMM/yyyy format
     */
    set value(value) {
      this.element.nativeElement.value = value;
    }
    get value() {
      return this.element.nativeElement.value;
    }
    /**
     * Minimum date user can select.
     */
    set minDate(value) {
      this.element.nativeElement.minDate = value;
    }
    get minDate() {
      return this.element.nativeElement.minDate;
    }
    /**
     * Maximum date user can select.
     */
    set maxDate(value) {
      this.element.nativeElement.maxDate = value;
    }
    get maxDate() {
      return this.element.nativeElement.maxDate;
    }
    /**
     * Disabled dates user cannot select.
     */
    set disabledDates(value) {
      this.element.nativeElement.disabledDates = value;
    }
    get disabledDates() {
      return this.element.nativeElement.disabledDates;
    }
    /**
     * Date format
     */
    set format(value) {
      this.element.nativeElement.format = value;
    }
    get format() {
      return this.element.nativeElement.format;
    }
    /**
     * Language code (ISO 639-1 + optional country code)
     */
    set lang(value) {
      this.element.nativeElement.lang = value;
    }
    get lang() {
      return this.element.nativeElement.lang;
    }
    /**
     * Whether range-datepicker should be disabled
     */
    set disabled(value) {
      this.element.nativeElement.disabled = value;
    }
    get disabled() {
      return this.element.nativeElement.disabled;
    }
    /**
     * Mark range-datepicker as required to be filled before submitting the form
     */
    set required(value) {
      this.element.nativeElement.required = value;
    }
    get required() {
      return this.element.nativeElement.required;
    }
    /**
     * Mark the range-datepicker as readonly
     */
    set readonly(value) {
      this.element.nativeElement.readonly = value;
    }
    get readonly() {
      return this.element.nativeElement.readonly;
    }
    /**
     * Whether range-datepicker should display button for clearing the inputs value.
     */
    set clearable(value) {
      this.element.nativeElement.clearable = value;
    }
    get clearable() {
      return this.element.nativeElement.clearable;
    }
    /**
     * Placeholder for range-datepicker control
     */
    set placeholder(value) {
      this.element.nativeElement.placeholder = value;
    }
    get placeholder() {
      return this.element.nativeElement.placeholder;
    }
    /**
     * Range-datepicker size
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * Marks component as a valid
     */
    set success(value) {
      this.element.nativeElement.success = value;
    }
    get success() {
      return this.element.nativeElement.success;
    }
    /**
     * Marks component as not valid
     */
    set error(value) {
      this.element.nativeElement.error = value;
    }
    get error() {
      return this.element.nativeElement.error;
    }
    /**
     * Marks component as conditionally valid
     */
    set warning(value) {
      this.element.nativeElement.warning = value;
    }
    get warning() {
      return this.element.nativeElement.warning;
    }
    /**
     * Validation message - success, error or warning
     */
    set explicitValidationMessage(value) {
      this.element.nativeElement.explicitValidationMessage = value;
    }
    get explicitValidationMessage() {
      return this.element.nativeElement.explicitValidationMessage;
    }
    /**
     * Set provided date as range-datepicker value
     */
    set(value) {
      this.element.nativeElement.set(value);
    }
    /**
     * Clear range-datepicker value
     */
    clear() {
      this.element.nativeElement.clear();
    }
    /**
     * Set focus on a range-datepicker
     */
    focus(options) {
      this.element.nativeElement.focus(options);
    }
    /**
     * Remove focus from range-datepicker making it inactive
     */
    blur() {
      this.element.nativeElement.blur();
    }
    input = new EventEmitter();
    change = new EventEmitter();
    handleInput() {
      this.handleValueChange();
    }
    handleChange() {
      this.handleValueChange();
    }
    handleValueChange() {
      const currentValue = this.element.nativeElement.value;
      if (currentValue !== this.previousValue) {
        this.previousValue = currentValue;
        this.onChange(currentValue);
      }
    }
    onChange = () => {};
    onTouch = () => {};
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouch = fn;
    }
    writeValue(value) {
      this.element.nativeElement.value = value;
    }
    setDisabledState(disabled) {
      this.disabled = disabled;
    }
    static ɵfac = function ChrRangeDatepickerDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrRangeDatepickerDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrRangeDatepickerDirective,
      selectors: [["chr-range-datepicker"]],
      hostBindings: function ChrRangeDatepickerDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("input", function ChrRangeDatepickerDirective_input_HostBindingHandler() {
            return ctx.handleInput();
          })("change", function ChrRangeDatepickerDirective_change_HostBindingHandler() {
            return ctx.handleChange();
          });
        }
      },
      inputs: {
        value: "value",
        minDate: [0, "min-date", "minDate"],
        maxDate: [0, "max-date", "maxDate"],
        disabledDates: "disabledDates",
        format: "format",
        lang: "lang",
        disabled: "disabled",
        required: "required",
        readonly: "readonly",
        clearable: "clearable",
        placeholder: "placeholder",
        size: "size",
        success: "success",
        error: "error",
        warning: "warning",
        explicitValidationMessage: [0, "validation-message", "explicitValidationMessage"]
      },
      outputs: {
        input: "input",
        change: "change"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ChrRangeDatepickerDirective),
        multi: true
      }])]
    });
  }
  return ChrRangeDatepickerDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrSelectDirective = /*#__PURE__*/(() => {
  class ChrSelectDirective {
    element;
    previousValue;
    constructor(element) {
      this.element = element;
    }
    /**
     * Size of the select
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * Marks select as disabled
     */
    set disabled(value) {
      this.element.nativeElement.disabled = value;
    }
    get disabled() {
      return this.element.nativeElement.disabled;
    }
    /**
     * Mark select as required to be filled before submitting the form
     */
    set required(value) {
      this.element.nativeElement.required = value;
    }
    get required() {
      return this.element.nativeElement.required;
    }
    /**
     * Mark select as readonly
     */
    set readonly(value) {
      this.element.nativeElement.readonly = value;
    }
    get readonly() {
      return this.element.nativeElement.readonly;
    }
    /**
     * Inputs value
     */
    set value(value) {
      this.element.nativeElement.value = value;
    }
    get value() {
      return this.element.nativeElement.value;
    }
    /**
     * Placeholder text for select component. It is displayed when no value is selected.
     */
    set placeholder(value) {
      this.element.nativeElement.placeholder = value;
    }
    get placeholder() {
      return this.element.nativeElement.placeholder;
    }
    /**
     * Prepending icon, if using CIPHR default icon set.
     * If you need to add icon outside of CIPHR icon set or anything else, please
     * use &#x60;icon&#x60; named slot.
     */
    set icon(value) {
      this.element.nativeElement.icon = value;
    }
    get icon() {
      return this.element.nativeElement.icon;
    }
    /**
     * Marks component as a valid
     */
    set success(value) {
      this.element.nativeElement.success = value;
    }
    get success() {
      return this.element.nativeElement.success;
    }
    /**
     * Marks component as not valid
     */
    set error(value) {
      this.element.nativeElement.error = value;
    }
    get error() {
      return this.element.nativeElement.error;
    }
    /**
     * Marks component as conditionally valid
     */
    set warning(value) {
      this.element.nativeElement.warning = value;
    }
    get warning() {
      return this.element.nativeElement.warning;
    }
    /**
     * Validation message - success, error or warning
     */
    set explicitValidationMessage(value) {
      this.element.nativeElement.explicitValidationMessage = value;
    }
    get explicitValidationMessage() {
      return this.element.nativeElement.explicitValidationMessage;
    }
    /**
     * Field name for screen readers. This should be used only when field is used without chr-label element.
     */
    set explicitLabel(value) {
      this.element.nativeElement.explicitLabel = value;
    }
    get explicitLabel() {
      return this.element.nativeElement.explicitLabel;
    }
    /**
     * Field description for screen readers. This should be used only when field is used without chr-label element.
     */
    set explicitDescription(value) {
      this.element.nativeElement.explicitDescription = value;
    }
    get explicitDescription() {
      return this.element.nativeElement.explicitDescription;
    }
    /**
     * Set provided option as select value
     */
    set(index) {
      this.element.nativeElement.set(index);
    }
    /**
     * Clear select value
     */
    clear() {
      this.element.nativeElement.clear();
    }
    /**
     * Set the focus on a specific element
     */
    focus(options) {
      this.element.nativeElement.focus(options);
    }
    /**
     * Remove the focus from an element making it inactive
     */
    blur() {
      this.element.nativeElement.blur();
    }
    change = new EventEmitter();
    handleChange() {
      this.handleValueChange();
    }
    handleValueChange() {
      const currentValue = this.element.nativeElement.value;
      if (currentValue !== this.previousValue) {
        this.previousValue = currentValue;
        this.onChange(currentValue);
      }
    }
    onChange = () => {};
    onTouch = () => {};
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouch = fn;
    }
    writeValue(value) {
      this.element.nativeElement.value = value;
    }
    setDisabledState(disabled) {
      this.disabled = disabled;
    }
    static ɵfac = function ChrSelectDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrSelectDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrSelectDirective,
      selectors: [["chr-select"]],
      hostBindings: function ChrSelectDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("change", function ChrSelectDirective_change_HostBindingHandler() {
            return ctx.handleChange();
          });
        }
      },
      inputs: {
        size: "size",
        disabled: "disabled",
        required: "required",
        readonly: "readonly",
        value: "value",
        placeholder: "placeholder",
        icon: "icon",
        success: "success",
        error: "error",
        warning: "warning",
        explicitValidationMessage: [0, "validation-message", "explicitValidationMessage"],
        explicitLabel: [0, "label", "explicitLabel"],
        explicitDescription: [0, "description", "explicitDescription"]
      },
      outputs: {
        change: "change"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ChrSelectDirective),
        multi: true
      }])]
    });
  }
  return ChrSelectDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrSideNavDirective = /*#__PURE__*/(() => {
  class ChrSideNavDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Defines the intensity level of the color shading for navigation elements.
     */
    set palette(value) {
      this.element.nativeElement.palette = value;
    }
    get palette() {
      return this.element.nativeElement.palette;
    }
    /**
     * When set to true, toggles the width of the side-nav.
     * It&#x27;s 64px wide without a visible drawer, 332px wide with the drawer visible, or 100% wide when the full-width property is set to true.
     */
    set opened(value) {
      this.element.nativeElement.opened = value;
    }
    get opened() {
      return this.element.nativeElement.opened;
    }
    /**
     * When true, prevents the side-nav from closing once opened.
     * It also hides the nav-group responsible for opening and hiding navigation drawer.
     */
    set uncollapsible(value) {
      this.element.nativeElement.uncollapsible = value;
    }
    get uncollapsible() {
      return this.element.nativeElement.uncollapsible;
    }
    /**
     * Sets side-nav component width to 100%.
     */
    set fullWidth(value) {
      this.element.nativeElement.fullWidth = value;
    }
    get fullWidth() {
      return this.element.nativeElement.fullWidth;
    }
    /**
     * Indicates whether the logo should be visible or not.
     */
    set logo(value) {
      this.element.nativeElement.logo = value;
    }
    get logo() {
      return this.element.nativeElement.logo;
    }
    /**
     * Indicates whether the logo should be visible or not.
     */
    set autoCollapse(value) {
      this.element.nativeElement.autoCollapse = value;
    }
    get autoCollapse() {
      return this.element.nativeElement.autoCollapse;
    }
    /**
     * Indicates if the nav-tree should be automatically scrolled to be visible in the viewport.
     */
    set autoScroll(value) {
      this.element.nativeElement.autoScroll = value;
    }
    get autoScroll() {
      return this.element.nativeElement.autoScroll;
    }
    /**
     * Marks the provided nav-item or nav-group as 'selected'.
     * If a nav-item is provided, it will also select its corresponding nav-group.
     */
    selectItem(item) {
      this.element.nativeElement.selectItem(item);
    }
    /**
     * Emits when nav-group or nav-item nested in nav-group is clicked.
     */
    chrAction = new EventEmitter();
    /**
     * Emits an event when any property changes, providing changed properties as event detail.
     */
    chrUpdated = new EventEmitter();
    static ɵfac = function ChrSideNavDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrSideNavDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrSideNavDirective,
      selectors: [["chr-side-nav"]],
      inputs: {
        palette: "palette",
        opened: "opened",
        uncollapsible: "uncollapsible",
        fullWidth: [0, "full-width", "fullWidth"],
        logo: "logo",
        autoCollapse: [0, "auto-collapse", "autoCollapse"],
        autoScroll: [0, "auto-scroll", "autoScroll"]
      },
      outputs: {
        chrAction: "chr-action",
        chrUpdated: "chr-updated"
      }
    });
  }
  return ChrSideNavDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrSnackbarDirective = /*#__PURE__*/(() => {
  class ChrSnackbarDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Snackbar variant
     */
    set variant(value) {
      this.element.nativeElement.variant = value;
    }
    get variant() {
      return this.element.nativeElement.variant;
    }
    /**
     * Describes color palette of the snackbar
     */
    set palette(value) {
      this.element.nativeElement.palette = value;
    }
    get palette() {
      return this.element.nativeElement.palette;
    }
    /**
     * Emits when snackbar is clicked.
     */
    chrAction = new EventEmitter();
    static ɵfac = function ChrSnackbarDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrSnackbarDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrSnackbarDirective,
      selectors: [["chr-snackbar"]],
      inputs: {
        variant: "variant",
        palette: "palette"
      },
      outputs: {
        chrAction: "chr-action"
      }
    });
  }
  return ChrSnackbarDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrSortIconDirective = /*#__PURE__*/(() => {
  class ChrSortIconDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Size of the sort icon
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * Specifies whether the icon should indicate ascending order.
     */
    set ascend(value) {
      this.element.nativeElement.ascend = value;
    }
    get ascend() {
      return this.element.nativeElement.ascend;
    }
    /**
     * Specifies whether the icon should indicate descending order.
     */
    set descend(value) {
      this.element.nativeElement.descend = value;
    }
    get descend() {
      return this.element.nativeElement.descend;
    }
    static ɵfac = function ChrSortIconDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrSortIconDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrSortIconDirective,
      selectors: [["chr-sort-icon"]],
      inputs: {
        size: "size",
        ascend: "ascend",
        descend: "descend"
      }
    });
  }
  return ChrSortIconDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrSpinnerDirective = /*#__PURE__*/(() => {
  class ChrSpinnerDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Size of the spinner
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * Describes color palette of the spinner
     */
    set palette(value) {
      this.element.nativeElement.palette = value;
    }
    get palette() {
      return this.element.nativeElement.palette;
    }
    static ɵfac = function ChrSpinnerDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrSpinnerDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrSpinnerDirective,
      selectors: [["chr-spinner"]],
      inputs: {
        size: "size",
        palette: "palette"
      }
    });
  }
  return ChrSpinnerDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrTabDirective = /*#__PURE__*/(() => {
  class ChrTabDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Marks tab as selected
     */
    set selected(value) {
      this.element.nativeElement.selected = value;
    }
    get selected() {
      return this.element.nativeElement.selected;
    }
    /**
     * Marks tab as disabled
     */
    set disabled(value) {
      this.element.nativeElement.disabled = value;
    }
    get disabled() {
      return this.element.nativeElement.disabled;
    }
    /**
     * Label of the tab
     */
    set label(value) {
      this.element.nativeElement.label = value;
    }
    get label() {
      return this.element.nativeElement.label;
    }
    /**
     * Tabid will be emitted in action&#x27;s event detail.
     */
    set tabid(value) {
      this.element.nativeElement.tabid = value;
    }
    get tabid() {
      return this.element.nativeElement.tabid;
    }
    /**
     * Prepending icon, if using CIPHR default icon set.
     * If you need to add icon outside of CIPHR icon set or anything else, please
     * use &#x60;icon&#x60; named slot.
     */
    set icon(value) {
      this.element.nativeElement.icon = value;
    }
    get icon() {
      return this.element.nativeElement.icon;
    }
    /**
     * Sets 'selected' state for the tab element
     */
    select() {
      this.element.nativeElement.select();
    }
    /**
     * Removes 'selected' state from the tab element
     */
    deselect() {
      this.element.nativeElement.deselect();
    }
    /**
     * Set the focus on a specific element
     */
    focus(options) {
      this.element.nativeElement.focus(options);
    }
    /**
     * Remove the focus from an element making it inactive
     */
    blur() {
      this.element.nativeElement.blur();
    }
    /**
     * Emits when tab is clicked.
     */
    chrTabSelected = new EventEmitter();
    static ɵfac = function ChrTabDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrTabDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrTabDirective,
      selectors: [["chr-tab"]],
      inputs: {
        selected: "selected",
        disabled: "disabled",
        label: "label",
        tabid: "tabid",
        icon: "icon"
      },
      outputs: {
        chrTabSelected: "chr-tab-selected"
      }
    });
  }
  return ChrTabDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrTabGroupDirective = /*#__PURE__*/(() => {
  class ChrTabGroupDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Size of the tab-group
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * Removes tab-group border bottom
     */
    set borderless(value) {
      this.element.nativeElement.borderless = value;
    }
    get borderless() {
      return this.element.nativeElement.borderless;
    }
    /**
     * Sets provided tab as selected
     */
    select(indexOrValue) {
      this.element.nativeElement.select(indexOrValue);
    }
    static ɵfac = function ChrTabGroupDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrTabGroupDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrTabGroupDirective,
      selectors: [["chr-tab-group"]],
      inputs: {
        size: "size",
        borderless: "borderless"
      }
    });
  }
  return ChrTabGroupDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrTextareaDirective = /*#__PURE__*/(() => {
  class ChrTextareaDirective {
    element;
    previousValue;
    constructor(element) {
      this.element = element;
    }
    /**
     * Size of the textarea
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * Marks textarea as disabled
     */
    set disabled(value) {
      this.element.nativeElement.disabled = value;
    }
    get disabled() {
      return this.element.nativeElement.disabled;
    }
    /**
     * Mark ztextarea as required to be filled before submitting the form
     */
    set required(value) {
      this.element.nativeElement.required = value;
    }
    get required() {
      return this.element.nativeElement.required;
    }
    /**
     * Mark textarea as readonly
     */
    set readonly(value) {
      this.element.nativeElement.readonly = value;
    }
    get readonly() {
      return this.element.nativeElement.readonly;
    }
    /**
     * Textarea value
     */
    set value(value) {
      this.element.nativeElement.value = value;
    }
    get value() {
      return this.element.nativeElement.value;
    }
    /**
     * Textarea placeholder
     */
    set placeholder(value) {
      this.element.nativeElement.placeholder = value;
    }
    get placeholder() {
      return this.element.nativeElement.placeholder;
    }
    /**
     * Marks component as a valid
     */
    set success(value) {
      this.element.nativeElement.success = value;
    }
    get success() {
      return this.element.nativeElement.success;
    }
    /**
     * Marks component as not valid
     */
    set error(value) {
      this.element.nativeElement.error = value;
    }
    get error() {
      return this.element.nativeElement.error;
    }
    /**
     * Marks component as conditionally valid
     */
    set warning(value) {
      this.element.nativeElement.warning = value;
    }
    get warning() {
      return this.element.nativeElement.warning;
    }
    /**
     * Validation message - success, error or warning
     */
    set explicitValidationMessage(value) {
      this.element.nativeElement.explicitValidationMessage = value;
    }
    get explicitValidationMessage() {
      return this.element.nativeElement.explicitValidationMessage;
    }
    /**
     * Field name for screen readers. This should be used only when field is used without chr-label element.
     */
    set explicitLabel(value) {
      this.element.nativeElement.explicitLabel = value;
    }
    get explicitLabel() {
      return this.element.nativeElement.explicitLabel;
    }
    /**
     * Field description for screen readers. This should be used only when field is used without chr-label element.
     */
    set explicitDescription(value) {
      this.element.nativeElement.explicitDescription = value;
    }
    get explicitDescription() {
      return this.element.nativeElement.explicitDescription;
    }
    /**
     * Sets text-area value
     */
    set(value) {
      this.element.nativeElement.set(value);
    }
    /**
     * Clears text-area value
     */
    clear() {
      this.element.nativeElement.clear();
    }
    /**
     * Set the focus on a specific element
     */
    focus(options) {
      this.element.nativeElement.focus(options);
    }
    /**
     * Remove the focus from an element making it inactive
     */
    blur() {
      this.element.nativeElement.blur();
    }
    input = new EventEmitter();
    change = new EventEmitter();
    handleInput() {
      this.handleValueChange();
    }
    handleChange() {
      this.handleValueChange();
    }
    handleValueChange() {
      const currentValue = this.element.nativeElement.value;
      if (currentValue !== this.previousValue) {
        this.previousValue = currentValue;
        this.onChange(currentValue);
      }
    }
    onChange = () => {};
    onTouch = () => {};
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouch = fn;
    }
    writeValue(value) {
      this.element.nativeElement.value = value;
    }
    setDisabledState(disabled) {
      this.disabled = disabled;
    }
    static ɵfac = function ChrTextareaDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrTextareaDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrTextareaDirective,
      selectors: [["chr-text-area"]],
      hostBindings: function ChrTextareaDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("input", function ChrTextareaDirective_input_HostBindingHandler() {
            return ctx.handleInput();
          })("change", function ChrTextareaDirective_change_HostBindingHandler() {
            return ctx.handleChange();
          });
        }
      },
      inputs: {
        size: "size",
        disabled: "disabled",
        required: "required",
        readonly: "readonly",
        value: "value",
        placeholder: "placeholder",
        success: "success",
        error: "error",
        warning: "warning",
        explicitValidationMessage: [0, "validation-message", "explicitValidationMessage"],
        explicitLabel: [0, "label", "explicitLabel"],
        explicitDescription: [0, "description", "explicitDescription"]
      },
      outputs: {
        input: "input",
        change: "change"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ChrTextareaDirective),
        multi: true
      }])]
    });
  }
  return ChrTextareaDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrThemeEditorDirective = /*#__PURE__*/(() => {
  class ChrThemeEditorDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Brand color selected by user.
     * Default color is set to primitive/accent/700 token value.
     */
    set color(value) {
      this.element.nativeElement.color = value;
    }
    get color() {
      return this.element.nativeElement.color;
    }
    /**
     * Brand font selected by user.
     */
    set font(value) {
      this.element.nativeElement.font = value;
    }
    get font() {
      return this.element.nativeElement.font;
    }
    /**
     * An array containing hexadecimal color values.
     * Used for generating color selection controls.
     */
    set predefinedColors(value) {
      this.element.nativeElement.predefinedColors = value;
    }
    get predefinedColors() {
      return this.element.nativeElement.predefinedColors;
    }
    /**
     * An array of objects defining font-family, font name, and description.
     * Used for generating font selection controls.
     */
    set predefinedFonts(value) {
      this.element.nativeElement.predefinedFonts = value;
    }
    get predefinedFonts() {
      return this.element.nativeElement.predefinedFonts;
    }
    /**
     * Defines if font picker should be visible or not.
     */
    set fontSwitcherVisible(value) {
      this.element.nativeElement.fontSwitcherVisible = value;
    }
    get fontSwitcherVisible() {
      return this.element.nativeElement.fontSwitcherVisible;
    }
    /**
     * Theme generated by themeGenerator.
     */
    set theme(value) {
      this.element.nativeElement.theme = value;
    }
    get theme() {
      return this.element.nativeElement.theme;
    }
    /**
     * Palette with accent colors generated by themeGenerator.
     */
    set accentPalette(value) {
      this.element.nativeElement.accentPalette = value;
    }
    get accentPalette() {
      return this.element.nativeElement.accentPalette;
    }
    /**
     * Palette with neutral colors generated by themeGenerator.
     */
    set neutralPalette(value) {
      this.element.nativeElement.neutralPalette = value;
    }
    get neutralPalette() {
      return this.element.nativeElement.neutralPalette;
    }
    /**
     * Emits when themeGenerator returns generated theme. Generated theme will be emitted in the event detail.
     */
    chrCompleted = new EventEmitter();
    static ɵfac = function ChrThemeEditorDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrThemeEditorDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrThemeEditorDirective,
      selectors: [["chr-theme-editor"]],
      inputs: {
        color: "color",
        font: "font",
        predefinedColors: "predefinedColors",
        predefinedFonts: "predefinedFonts",
        fontSwitcherVisible: [0, "font-picker", "fontSwitcherVisible"],
        theme: "theme",
        accentPalette: "accentPalette",
        neutralPalette: "neutralPalette"
      },
      outputs: {
        chrCompleted: "chr-completed"
      }
    });
  }
  return ChrThemeEditorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrTileDirective = /*#__PURE__*/(() => {
  class ChrTileDirective {
    element;
    previousValue;
    constructor(element) {
      this.element = element;
    }
    /**
     * Marks tile as disabled
     */
    set disabled(value) {
      this.element.nativeElement.disabled = value;
    }
    get disabled() {
      return this.element.nativeElement.disabled;
    }
    /**
     * Marks tile as selected
     */
    set selected(value) {
      this.element.nativeElement.selected = value;
    }
    get selected() {
      return this.element.nativeElement.selected;
    }
    /**
     * Set name for tiles inside tile-group
     */
    set name(value) {
      this.element.nativeElement.name = value;
    }
    get name() {
      return this.element.nativeElement.name;
    }
    /**
     * Tile value
     */
    set value(value) {
      this.element.nativeElement.value = value;
    }
    get value() {
      return this.element.nativeElement.value;
    }
    /**
     * Sets 'selected' state for the tile
     */
    select() {
      this.element.nativeElement.select();
    }
    /**
     * Removes 'selected' state from the tile
     */
    deselect() {
      this.element.nativeElement.deselect();
    }
    /**
     * Set the focus on a specific element
     */
    focus(options) {
      this.element.nativeElement.focus(options);
    }
    /**
     * Remove the focus from an element making it inactive
     */
    blur() {
      this.element.nativeElement.blur();
    }
    change = new EventEmitter();
    handleChange() {
      this.handleValueChange();
    }
    handleValueChange() {
      const currentValue = this.element.nativeElement.value;
      this.onChange(currentValue);
    }
    onChange = () => {};
    onTouch = () => {};
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouch = fn;
    }
    writeValue(value) {
      this.element.nativeElement.selected = value === this.value;
    }
    setDisabledState(disabled) {
      this.disabled = disabled;
    }
    static ɵfac = function ChrTileDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrTileDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrTileDirective,
      selectors: [["chr-tile"]],
      hostBindings: function ChrTileDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("change", function ChrTileDirective_change_HostBindingHandler() {
            return ctx.handleChange();
          });
        }
      },
      inputs: {
        disabled: "disabled",
        selected: "selected",
        name: "name",
        value: "value"
      },
      outputs: {
        change: "change"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ChrTileDirective),
        multi: true
      }])]
    });
  }
  return ChrTileDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrTileGroupDirective = /*#__PURE__*/(() => {
  class ChrTileGroupDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Specifies layout direction of the tile within the group
     */
    set direction(value) {
      this.element.nativeElement.direction = value;
    }
    get direction() {
      return this.element.nativeElement.direction;
    }
    /**
     * Set name for tiles inside tile-group
     */
    set name(value) {
      this.element.nativeElement.name = value;
    }
    get name() {
      return this.element.nativeElement.name;
    }
    static ɵfac = function ChrTileGroupDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrTileGroupDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrTileGroupDirective,
      selectors: [["chr-tile-group"]],
      inputs: {
        direction: "direction",
        name: "name"
      }
    });
  }
  return ChrTileGroupDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrToastDirective = /*#__PURE__*/(() => {
  class ChrToastDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Describes color palette of the toast
     */
    set palette(value) {
      this.element.nativeElement.palette = value;
    }
    get palette() {
      return this.element.nativeElement.palette;
    }
    /**
     * Toast title
     */
    set title(value) {
      this.element.nativeElement.title = value;
    }
    get title() {
      return this.element.nativeElement.title;
    }
    /**
     * Hides icon-button responsible for closing toast
     */
    set unclosable(value) {
      this.element.nativeElement.unclosable = value;
    }
    get unclosable() {
      return this.element.nativeElement.unclosable;
    }
    /**
     * Emits when close button is clicked.
     */
    chrClose = new EventEmitter();
    static ɵfac = function ChrToastDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrToastDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrToastDirective,
      selectors: [["chr-toast"]],
      inputs: {
        palette: "palette",
        title: "title",
        unclosable: "unclosable"
      },
      outputs: {
        chrClose: "chr-close"
      }
    });
  }
  return ChrToastDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrToggleDirective = /*#__PURE__*/(() => {
  class ChrToggleDirective {
    element;
    previousValue;
    constructor(element) {
      this.element = element;
    }
    /**
     * Size of the toggle button
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * Marks toggle button as selected
     */
    set selected(value) {
      this.element.nativeElement.selected = value;
    }
    get selected() {
      return this.element.nativeElement.selected;
    }
    /**
     * Marks toggle button as disabled
     */
    set disabled(value) {
      this.element.nativeElement.disabled = value;
    }
    get disabled() {
      return this.element.nativeElement.disabled;
    }
    /**
     * Mark toggle as required to be checked before submitting the form
     */
    set required(value) {
      this.element.nativeElement.required = value;
    }
    get required() {
      return this.element.nativeElement.required;
    }
    /**
     * Mark toggle as readonly
     */
    set readonly(value) {
      this.element.nativeElement.readonly = value;
    }
    get readonly() {
      return this.element.nativeElement.readonly;
    }
    /**
     * Label of the toggle button
     */
    set label(value) {
      this.element.nativeElement.label = value;
    }
    get label() {
      return this.element.nativeElement.label;
    }
    /**
     * Value of the toggle button that will be emitted in action&#x27;s event detail
     */
    set value(value) {
      this.element.nativeElement.value = value;
    }
    get value() {
      return this.element.nativeElement.value;
    }
    /**
     * Toggles 'selected' state
     */
    toggle() {
      this.element.nativeElement.toggle();
    }
    /**
     * Sets provided state for the toggle
     */
    set(value) {
      this.element.nativeElement.set(value);
    }
    /**
     * Clears toggle state
     */
    clear() {
      this.element.nativeElement.clear();
    }
    /**
     * Set the focus on a specific element
     */
    focus(options) {
      this.element.nativeElement.focus(options);
    }
    /**
     * Remove the focus from an element making it inactive
     */
    blur() {
      this.element.nativeElement.blur();
    }
    /**
     * Emits when toggle button is clicked and not disabled.
     */
    chrAction = new EventEmitter();
    change = new EventEmitter();
    handleChange() {
      this.handleValueChange();
    }
    handleValueChange() {
      const currentValue = this.element.nativeElement.value;
      if (currentValue !== this.previousValue) {
        this.previousValue = currentValue;
        this.onChange(currentValue);
      }
    }
    onChange = () => {};
    onTouch = () => {};
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouch = fn;
    }
    writeValue(value) {
      this.element.nativeElement.selected = value;
    }
    setDisabledState(disabled) {
      this.disabled = disabled;
    }
    static ɵfac = function ChrToggleDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrToggleDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrToggleDirective,
      selectors: [["chr-toggle"]],
      hostBindings: function ChrToggleDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("change", function ChrToggleDirective_change_HostBindingHandler() {
            return ctx.handleChange();
          });
        }
      },
      inputs: {
        size: "size",
        selected: "selected",
        disabled: "disabled",
        required: "required",
        readonly: "readonly",
        label: "label",
        value: "value"
      },
      outputs: {
        chrAction: "chr-action",
        change: "change"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ChrToggleDirective),
        multi: true
      }])]
    });
  }
  return ChrToggleDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChrValidationMessageDirective = /*#__PURE__*/(() => {
  class ChrValidationMessageDirective {
    element;
    constructor(element) {
      this.element = element;
    }
    /**
     * Size of the helper
     */
    set size(value) {
      this.element.nativeElement.size = value;
    }
    get size() {
      return this.element.nativeElement.size;
    }
    /**
     * Text to show in helper
     */
    set content(value) {
      this.element.nativeElement.content = value;
    }
    get content() {
      return this.element.nativeElement.content;
    }
    /**
     * Display success helper
     */
    set success(value) {
      this.element.nativeElement.success = value;
    }
    get success() {
      return this.element.nativeElement.success;
    }
    /**
     * Display warning helper
     */
    set warning(value) {
      this.element.nativeElement.warning = value;
    }
    get warning() {
      return this.element.nativeElement.warning;
    }
    /**
     * Display error helper
     */
    set error(value) {
      this.element.nativeElement.error = value;
    }
    get error() {
      return this.element.nativeElement.error;
    }
    static ɵfac = function ChrValidationMessageDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrValidationMessageDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ChrValidationMessageDirective,
      selectors: [["chr-validation-message"]],
      inputs: {
        size: "size",
        content: "content",
        success: "success",
        warning: "warning",
        error: "error"
      }
    });
  }
  return ChrValidationMessageDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const appInitializer = (document, userOptions) => {
  const options = {
    iconsUrl: '/icons',
    illustrationsUrl: '/illustrations',
    components: false,
    polyfills: false,
    ...userOptions
  };
  return async () => {
    // prettier-ignore
    // @ts-expect-error - packagr can't find the package.
    const {
      registerIcons
    } = await import('@ciphr-design-system/components/icon-catalog');
    // prettier-ignore
    // @ts-expect-error - packagr can't find the package.
    const {
      icons
    } = await import('@ciphr-design-system/icons');
    // prettier-ignore
    // @ts-expect-error - packagr can't find the package.
    const {
      registerIllustrations
    } = await import('@ciphr-design-system/components/illustration-catalog');
    // prettier-ignore
    // @ts-expect-error - packagr can't find the package.
    const {
      illustrations
    } = await import('@ciphr-design-system/illustrations');
    registerIcons({
      url: options?.iconsUrl,
      icons
    });
    registerIllustrations({
      url: options?.illustrationsUrl,
      illustrations
    });
    if (options.components) {
      // prettier-ignore
      // @ts-expect-error - packagr can't find the package.
      await import('@ciphr-design-system/components/components');
    }
    if (options.polyfills) {
      // prettier-ignore
      // @ts-expect-error - packagr can't find the package.
      await import('@ciphr-design-system/components/polyfills');
    }
    if (options.defaultTheme) {
      // @ts-expect-error - packagr can't find the package.
      const {
        themesMeta
      } = await import('@ciphr-design-system/foundations');
      const theme = themesMeta.find(theme => theme.id === options.defaultTheme);
      if (theme) {
        document.body.classList.add(theme.className);
      }
    }
  };
};
const CIPHR_DESIGN_SYSTEM_CONFIG = new InjectionToken('CIPHR_DESIGN_SYSTEM_CONFIG');
let ChrComponentsModule = /*#__PURE__*/(() => {
  class ChrComponentsModule {
    static forRoot(config) {
      return {
        ngModule: ChrComponentsModule,
        providers: [{
          provide: CIPHR_DESIGN_SYSTEM_CONFIG,
          useValue: config,
          multi: false
        }, {
          provide: APP_INITIALIZER,
          useFactory: appInitializer,
          deps: [DOCUMENT, CIPHR_DESIGN_SYSTEM_CONFIG],
          multi: true
        }]
      };
    }
    static ɵfac = function ChrComponentsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChrComponentsModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ChrComponentsModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
  return ChrComponentsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { CIPHR_DESIGN_SYSTEM_CONFIG, ChrAccordionDirective, ChrAvatarDirective, ChrBadgeDirective, ChrButtonDirective, ChrButtonGroupDirective, ChrButtonGroupItemDirective, ChrButtonIconDirective, ChrCalendarDirective, ChrCheckboxDirective, ChrCheckboxGroupDirective, ChrChipDirective, ChrComponentsModule, ChrDatepickerDirective, ChrFormFieldDirective, ChrHelperDirective, ChrIconDirective, ChrIllustrationDirective, ChrInlineMessageDirective, ChrInputDirective, ChrInputNumberDirective, ChrInputPasswordDirective, ChrLabelDirective, ChrMenuDirective, ChrMenuOverlayDirective, ChrModalBodyDirective, ChrModalDirective, ChrModalFooterDirective, ChrModalHeaderDirective, ChrModalOverlayDirective, ChrMultiSelectDirective, ChrNavGroupDirective, ChrNavItemDirective, ChrNavTreeDirective, ChrPaginationDirective, ChrPillDirective, ChrRadioDirective, ChrRadioGroupDirective, ChrRangeDatepickerDirective, ChrSelectDirective, ChrSideNavDirective, ChrSnackbarDirective, ChrSortIconDirective, ChrSpinnerDirective, ChrTabDirective, ChrTabGroupDirective, ChrTextareaDirective, ChrThemeEditorDirective, ChrTileDirective, ChrTileGroupDirective, ChrToastDirective, ChrToggleDirective, ChrValidationMessageDirective, appInitializer };
